<template>
	<div id="AppTopBar" 
		:class="{
			'layout-topbar': true,
			'no-current-process_model': store.process_model_current &&
										store.process_model_current !== store.process_model_record?.id,
			'workspace-alarm': !!workspaceAlarm
		}"
	>
		<div class="topbar-left" :class="{'chips-single-row': !chipsMultiRow}">
			<!-- IE 2026 10 08 / ODOO-5800 (скрин Игоря, шапка «Закупівлі»): кнопка «рабочие области» ☰ вынесена из topbar-left-1 — при узких чипсах (многострочный режим) в первой строке   // IE 2026 11 02 / ODOO-349799 (workspace-wording)
			     остаётся только название стола (бейдж задач — при названии), а ☰, «Страницы» и ⊞ меню страницы уходят на вторую строку одной группой (CSS order);
			     при широкой шапке — в одну строку, как было: ☰ → название → ▯ → ⊞. Клик и наведение на ☰ — прежние -->
			<!-- IE 2026 10 29 / ODOO-5800 (заказ Игоря 29.10: иконка панели столов — «panel-left» с состоянием открыто/закрыто; «Страницы» в шапке — глиф вкладок): вместо ☰ — рамка окна с чертой слева (панель закрыта, клик открывает) / с залитой левой третью (панель открыта, та же кнопка закрывает);
			     глиф следует состоянию панели (prop menuOpen из App.vue sidebarOpen), а не клику — панель закрывается и уходом мыши / выбором стола; объяснение по Alt — состояние open / closed -->
			<button class="p-link p-link-topbar-1 p-link-topbar topbar-ws-btn" v-uiHelp="wsBtnHelp"
				@click="onMenuToggle"
				@mouseenter="handleMouseEnter"
				@mouseleave="$emit('hover-unlock')"
			><!-- IE 2026 10 29 / ODOO-5800 (заказ Игоря 29.10: кнопка «закрыть список столов» на месте кнопки шапки — без повторного открытия наведением): уход мыши с кнопки снимает запрет открытия наведением (App.vue sidebarHoverLock) -->
				<i :class="menuOpen ? 'pi ie-ico-panel-close' : 'pi ie-ico-panel-open'"></i>
			</button>
			<div class="topbar-left-1">
				<!-- «большие три точки»-разделитель убраны: путались с «⋮» оверфлоу-меню -->
				<!-- IE 2026 09 22 / ODOO-… (заказ Игоря, п.5): панель страниц стола открывается по наведению на заголовок в шапке (fe.ux.pagesMenuOnTitle;
				     выкл — прежняя иконка в topbar-left-2); в панели: страницы бейджами, текущая выделена, «только избранные», поиск -->
				<!-- IE 2026 09 23 / ODOO-341407: i18n -->
				<!-- IE 2026 09 26 / ODOO-… (замечания Игоря: рейл и шапка) (п. 3.3): название стола — триггер ПАНЕЛИ ЗАДАЧ (та же панель, что была иконкой после меню страницы: пункты, статусы, ↻, избранное),
				     красный бейдж ошибок последнего запуска — у названия; прежняя иконка задач не рисуется; панель страниц — на кнопке рейла (п. 3.2).
				     Выключатель fe.ux.tasksPanelOnTitle; название занято панелью страниц (fe.ux.pagesPanelOnRailToggle = false) — задачи иконкой, как раньше -->
				<!-- IE 2026 11 03 / ODOO-350449 (заказ Игоря: p225 єдине меню робочої області, етап 2 — «Показывать ее по нажатию на … заголовок с тайтлом рабочей области … меню, которое сейчас выпадает … убрать»): клик по названию стола открывает
				     форму меню рабочей области (WorkspaceMenuForm, вкладка Menu; наведение не открывает), отдельной кнопки ⊞ нет; прежняя панель задач на названии и панель страниц на
				     кнопке рейла не рисуются; красный бейдж ошибок задач — у названия, с объяснением по Alt (topbar.tasksBadge). Тот же ref — правая кнопка по столу и «All pages…» рейла.
				     Выключатель fe.ux.workspaceMenuOnTitle (store.workspaceMenuOnTitle_on; false — как в этапе 1) -->
				<span v-if="store.activeWORKSPACE && wsMenuOnTitle">
					<WorkspaceMenuForm ref="pageMenuPanel" class="page-menu-ws ws-menu-title" :pageBind="pageMenuBind" :tasksBind="tasksPanelOn ? tasksMenuBind : null" :settingsItem="tasksSettingsItem"
						:btnBadge="wsTitleBadge" :hoverOpen="false" btnClass="p-link workspace-title-btn tasks-title-btn ws-menu-title-btn">
						<template #trigger><span class="workspace-title">{{ titleTopBar }}</span></template>
						<template #card="{ raw }"><WidgetPreviewImg :pic="pageMenuPicOf(raw)" :icon="pageMenuIconOf(raw)" :title="pageMenuTitleOf(raw)" :lay="pageMenuLayOf(raw)" :fill="false" /></template>
					</WorkspaceMenuForm>
				</span>
				<span v-else-if="store.activeWORKSPACE && tasksOnTitle">
					<!-- IE 2026 10 03 / ODOO-345044 (заказ Игоря: кнопка «Страницы» в шапку, hover-меню с задержкой, скрытие рейки кнопкой в меню): пауза наведения — fe.ux.menuHoverOpenMs (menuHoverMs) -->
					<MenuPanel class="tasks-menu tasks-menu-title" :openDelay="menuHoverMs" :hover="tasksMenuHover" :items="tasksPanelItems" icon="pi ie-ico-tasks-panel" :caret="false" :title="t('Tasks')" :subtitle="menuSub_workspace"
						btnClass="p-link workspace-title-btn tasks-menu-btn tasks-title-btn" :btnBadge="tasksErrBadge" search :searchPlaceholder="t('Search tasks…')" :runsTitle="t('Tasks')"
						:tooltip="tasksPanelTooltip" :favKey="tasksFavKey" :favOf="tasksFavOf" :epoch="store._favEpoch" :favTitle="t('Favourite task (for this workspace)')"
						refresh :refreshBusy="tasksPanelBusy" :refreshTitle="tasksRefreshTitle" help="tasks" :helpVars="tasksHelpVars"
						@open="tasksPanelOpened" @pick="tasksPanelPick" @fav="tasksPanelFav" @refresh="tasksPanelRefresh">
						<template #trigger><span class="workspace-title">{{ titleTopBar }}</span></template>
					</MenuPanel>
				</span>
				<span v-else-if="store.activeWORKSPACE && pagesOnTitle">
					<!-- IE 2026 09 24 / ODOO-… (заказ Игоря: заголовок панелей-меню): ряд «Pages · стол» (панель страниц на заголовке стола; иконка ряда — ie-ico-tabs, у кнопки слот) -->
					<!-- IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt): help — вид панели для объяснений элементов по Alt (utils/uiHelp/menuPanel.js) -->
					<!-- IE 2026 09 26 / ODOO-… (заказ Игоря: виды панели страниц): панель страниц — компонент PagesPanel (содержимое, виды Pages / Pages and widgets / Previews, превью); здесь только триггер -->
					<PagesPanel class="pages-menu" :openDelay="menuHoverMs" :hover="menuHoverMs > 0" btnClass="p-link workspace-title-btn pages-menu-btn">
						<template #trigger><span class="workspace-title">{{ titleTopBar }}</span></template>
					</PagesPanel>
				</span>
				<span v-else><div class="workspace-title" v-if="store.activeWORKSPACE" v-uiHelp="'topbar.title'">{{ titleTopBar }}</div></span>
				<!-- IE 2026 09 26 / ODOO-… (замечания Игоря: рейл и шапка) (п. 3.2): панель страниц открывается наведением на кнопку скрытия рейла (вверху рейла, Page.vue) — тот же PagesPanel, своей кнопки
				     нет (anchor), панель встаёт справа от кнопки; пока открыта — кнопка подсвечена (store.pagesPanelOpen). Выключатель fe.ux.pagesPanelOnRailToggle -->
				<PagesPanel v-if="store.activeWORKSPACE && pagesOnRailToggle && !pagesBtnMode && !wsMenuOnTitle" class="pages-menu pages-menu-rail" anchor=".pages-rail-toggle-top" side="right" :openDelay="220"
					@open="store.pagesPanelOpen = true" @close="store.pagesPanelOpen = false" />
				<!-- IE 2026 10 03 / ODOO-345044 (заказ Игоря: кнопка «Страницы» в шапку, hover-меню с задержкой, скрытие рейки кнопкой в меню): кнопка «Страницы» — в шапке, сразу после названия стола (бейдж задач) и перед ⊞ меню страницы (fe.ux.pagesButtonInTopbar; выкл. — кнопка вверху рейла
				     и панель на ней, как было). Клик открывает / закрывает форму, как у остальных; наведение — с паузой fe.ux.menuHoverOpenMs. Последняя строка формы — «Hide pages rail» /
				     «Show pages rail» (прежняя работа кнопки; PagesPanel railRow → store.pagesRail_toggle). Кнопка есть, когда есть рейл (страниц больше одной) -->
				<!-- IE 2026 10 08 / ODOO-5800 (скрин Игоря, шапка «Закупівлі»): кнопка «Страницы» перенесена в topbar-left-2 — при узких чипсах (многострочный режим) на вторую строку
				     уходят ОБЕ кнопки, «Страницы» и ⊞ меню страницы, одной группой, а не по одной; порядок в строке прежний (название → ▯ → ⊞) -->
				<!-- IE 2026 09 15 / ODOO-… (замечание Игоря): метка открытых вариантов «Widgets: … · Filters: …» в шапке снята — текущий вариант отмечен в списках Commands → Filters / Widgets -->
				<!-- IE 2026 09 23 / ODOO-341407: i18n -->
				<i v-if="workspaceAlarm" class="pi pi-exclamation-triangle workspace-alarm-icon" v-uiHelp="'topbar.alarm'"
					v-wjTooltip="tn(workspaceAlarm.count, 'Critical tasks alarm: {n} task failed or stuck. Click for details.', 'Critical tasks alarm: {n} tasks failed or stuck. Click for details.')"
					@click="reopenAlarm"></i>
				<!-- IE 2026 09 29 / ODOO-342781: роль «только чтение» — бейдж в шапке (текст и подсказка по-английски, переводы uk / ru); без роли не рисуется -->
				<span v-if="store.readonly_on()" class="ro-badge" data-testid="readonly-badge" v-wjTooltip="t('You can browse everything; saving, running tasks and other changes are disabled')">
					<i class="pi pi-lock"></i><span class="ro-badge-text">{{ t('Read-only access') }}</span>
				</span>
				<!-- IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): открыта архивная ПМ — бейдж «Archive · read-only» (тот же вид, что у роли; без роли; выключатель fe.ux.pmArchiveReadOnly) -->
				<span v-if="!store.readonly_on() && store.readonly_archive()" class="ro-badge ro-badge-archive" data-testid="archive-readonly-badge" v-wjTooltip="t('This is a daily archive of the process model: you can browse it and compare with it; editing, saving and running tasks are disabled')">
					<i class="pi pi-history"></i><span class="ro-badge-text">{{ t('Archive · read-only') }}</span>
				</span>
			</div>

			<div class="topbar-left-2">
				<!-- IE 2026 10 08 / ODOO-5800: кнопка «Страницы» (была в topbar-left-1) — в одном неразрывном блоке с ⊞ меню страницы; свёртка в «⋮» (hideLeft2) — только у workspace-menu, как было -->
				<!-- IE 2026 10 29 / ODOO-5800 (заказ Игоря 29.10: иконка панели столов — «panel-left» с состоянием открыто/закрыто; «Страницы» в шапке — глиф вкладок): глиф кнопки «Страницы» — ie-ico-tabs, как у остальных кнопок панели страниц (ie-ico-sidebar похож на новую кнопку столов; на кнопке рейла и в строке «Hide pages rail» он остаётся) -->
				<PagesPanel v-if="pagesInTopbar" class="pages-menu pages-menu-topbar" icon="pi ie-ico-tabs" :btnClass="pagesTopbarBtnClass" railRow :openDelay="menuHoverMs" :hover="menuHoverMs > 0" />
				<div class="workspace-menu" ref="left2" :style="{ display: hideLeft2 ? 'none' : '' }">
					<!-- IE 2026 09 22 / ODOO-… (предложение Игоря): вместо выпадающих меню Widgets / Calc / More — одна иконка, по наведению / клику
					     открывается панель функций страницы в стиле 1С (components/MenuPanel.vue: группы колонками, вложенные пункты с тире);
					     прежние wj-menu — при выключенной настройке fe.ux.pageMenuPanel и в мобильном профиле -->
					<!-- IE 2026 09 22 / ODOO-… (заказ Игоря): панель страниц стола — поиск чипсами, под страницей виджеты, открываемые при её открытии;
					     звезда = страница в рейле (личное), домик = страница по умолчанию (личное) -->
					<!-- IE 2026 09 23 / ODOO-341407: i18n -->
					<!-- IE 2026 09 24 / ODOO-… (заказ Игоря: заголовок панелей-меню): ряд «Pages · стол» (панель страниц иконкой) -->
					<!-- IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt): help — вид панели для объяснений элементов по Alt (utils/uiHelp/menuPanel.js) -->
					<!-- IE 2026 09 26 / ODOO-… (заказ Игоря: виды панели страниц): панель страниц иконкой — тот же компонент PagesPanel -->
					<PagesPanel v-if="pageMenuPanelOn && !pagesOnTitle && !pagesOnRailToggle" class="pages-menu" :openDelay="menuHoverMs" :hover="menuHoverMs > 0" icon="pi ie-ico-tabs" btnClass="p-link p-link-topbar page-menu-btn pages-menu-btn" />
					<!-- IE 2026 09 22 (заказ Игоря): чипсы поиска по пунктам; звезда у виджета = избранный — открывается при открытии страницы -->
					<!-- IE 2026 09 22 (уточнение Игоря): звезда — только избранное; «открывается со страницей» — отдельная пометка (умолчания страницы, первое изменение
					     фиксирует личный набор целиком; кнопка сброса возвращает умолчания) -->
					<!-- IE 2026 09 23 / ODOO-341407: i18n -->
					<!-- IE 2026 09 24 / ODOO-… (заказ Игоря: заголовок панелей-меню): ряд «Page menu · текущая страница» -->
					<!-- IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt): help — вид панели для объяснений элементов по Alt (utils/uiHelp/menuPanel.js) -->
					<!-- IE 2026 10 08 / ODOO-5800 (скрины Игоря: «⋮» открывал не те формы): свойства и обработчики панели — одна таблица pageMenuBind, та же у строки «⋮» -->
					<!-- IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка на остальных элементах — рейл / чипс / стол): ref — правая кнопка по пустому месту стола открывает эту панель (ctxMenu_pageMenu) -->
					<!-- IE 2026 11 02 / ODOO-350449 (заказ Игоря: p214 єдине меню робочої області — вкладки Меню / Сторінки / Завдання): ⊞ — одна форма меню рабочей области с вкладками Menu / Pages / Tasks (WorkspaceMenuForm: меню страницы + команды страницы и фильтров, страницы стола, задачи);
					     тот же ref — правая кнопка по столу (ctxMenu_pageMenu) и пункт «All pages…» рейла (store.workspaceMenu_open → workspaceMenu_show). Выключатель fe.ux.workspaceMenuTabs (false — прежнее меню страницы ниже) -->
					<!-- IE 2026 11 03 / ODOO-350449 (заказ Игоря: p225 єдине меню робочої області, етап 2): форма на названии стола (wsMenuOnTitle) — кнопки ⊞ нет -->
					<template v-if="wsMenuTabsOn"><WorkspaceMenuForm v-if="!wsMenuOnTitle" ref="pageMenuPanel" class="page-menu-ws" :pageBind="pageMenuBind" :tasksBind="tasksPanelOn ? tasksMenuBind : null" :settingsItem="tasksSettingsItem" btnClass="p-link p-link-topbar page-menu-btn">
						<template #card="{ raw }"><WidgetPreviewImg :pic="pageMenuPicOf(raw)" :icon="pageMenuIconOf(raw)" :title="pageMenuTitleOf(raw)" :lay="pageMenuLayOf(raw)" :fill="false" /></template>
					</WorkspaceMenuForm></template>
					<MenuPanel v-else-if="pageMenuPanelOn" ref="pageMenuPanel" class="page-menu" v-bind="pageMenuBind" btnClass="p-link p-link-topbar page-menu-btn">
						<!-- IE 2026 09 27 / ODOO-… (заказ Игоря: картинки виджетов): вид «Widget previews» — карточки с картинками виджетов (у команд и виджетов без картинки — значок строки) -->
						<template #card="{ raw }"><WidgetPreviewImg :pic="pageMenuPicOf(raw)" :icon="pageMenuIconOf(raw)" :title="pageMenuTitleOf(raw)" :lay="pageMenuLayOf(raw)" :fill="false" /></template>
					</MenuPanel>
					<template v-else>
					<wj-menu
						v-for="(menu, index) in menuTree"
						:key="index"
						:id="'menu_' + index" v-uiHelp="'topbar.menus.fallback'"
						:header="menu.node?.valueStr"
						:displayMemberPath="'node.valueStr'"
						:subItemsPath="'attrs'"
						:showDropDownButton="false"
						:openOnHover="!store.mobileUi?.on"
						:isAnimated="false"
						:itemsSource="menu.attrs"
						:initialized="initMenu"
						:itemClicked="menuNodeClicked" :formatItem="store.formatMenuItem"
					/>
					</template>
					<!-- IE 2026 09 23 / ODOO-… (заказ Игоря: «если у пользователя административные права, то размещай иконку „формы-меню-задач“ на каждой странице
					     после иконки „формы-меню-страницы“ … клик по элементам приведёт к открытию виджета на текущей странице … бейдж с красным цветом …
					     количество задач из списка со статусом последнего выполнения с ошибками»): панель задач стола — свой глиф ie-ico-tasks-panel (планшет с
					     треугольником запуска), те же группы / пункты / бейджи статусов, что на вкладке Tasks panel формы стола (utils/tasksPanel.js); красный бейдж
					     на иконке = число задач, чей последний запуск завершился ошибкой; ↻ — перечитать статусы; только администраторам, fe.ux.menuPanelTasks -->
					<!-- IE 2026 09 24 / ODOO-… (заказ Игоря: заголовок панелей-меню): ряд «Tasks · стол» -->
					<!-- IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt): help — вид панели для объяснений элементов по Alt (utils/uiHelp/menuPanel.js) -->
					<!-- IE 2026 10 08 / ODOO-5800: свойства и обработчики панели — одна таблица tasksMenuBind, та же у строки «⋮» -->
					<MenuPanel v-if="tasksPanelOn && !tasksOnTitle && !wsMenuOnTitle" class="tasks-menu" v-bind="tasksMenuBind" btnClass="p-link p-link-topbar tasks-menu-btn" />   <!-- IE 2026 11 03 / ODOO-350449 (заказ Игоря: p225 єдине меню робочої області, етап 2): с формой на названии задачи — её вкладка Tasks -->
				</div>
			</div>
		</div>

		<div class="topbar-chips" v-if="topbarChipsAttr" ref="topbarChips">
			<AttrChips
				:initialAttr="topbarChipsAttr"
				:record="store.activeWORKSPACE?.record"
				:mode="'Page'"
			/>
		</div>

		<!-- IE 2026 09 23 / ODOO-341407: i18n -->
		<div v-if="alarmDialogVisible" class="workspace-alarm-overlay">
		<div class="workspace-alarm-dialog">
			<div class="workspace-alarm-header">
				<i class="pi pi-exclamation-triangle"></i>
				<span>{{ t('Critical tasks require attention') }}</span>
			</div>
			<div class="workspace-alarm-rows">
				<div v-for="r in workspaceAlarm.rows" :key="r.widget" class="workspace-alarm-row">
					<span class="workspace-alarm-badge" :class="'workspace-alarm-' + r.reason" v-uiHelp="{ key: 'topbar.alarm.badge', state: () => (r.reason === 'error' ? 'error' : 'stuck') }">
						{{ r.reason === 'error' ? t('Error') : t('Waiting > {n} min', { n: workspaceAlarm.waiting_minutes }) }}
					</span>
					<span class="workspace-alarm-task">{{ r.title || r.widget }}</span>
					<span class="workspace-alarm-comment">{{ r.comment }}</span>
					<span class="workspace-alarm-date">{{ r.created_at }}</span>
				</div>
			</div>
			<div class="workspace-alarm-footer">
				<button type="button" class="p-button p-component workspace-alarm-close" @click="ackAlarm" v-uiHelp="'topbar.alarm.continue'">{{ t('Continue') }}</button>
			</div>
		</div>
	</div>

	<div class="topbar-right" :class="{'chips-single-row': !chipsMultiRow}">
			<div class="topbar-right-1" ref="rightIcons">
				<!-- узкая шапка: не влезающие иконки сворачиваются в меню «⋮»
				     (как командная панель грида) — см. _measureRightIcons -->
				<button v-for="a in rightBarActions" :key="a.action" type="button"
					class="p-link p-link-topbar tb-right-icon" v-uiHelp="'topbar.right.' + a.action"
					@click="runRightAction(a)" v-wjTooltip="a.tooltip">
					<i :class="a.icon"></i>
				</button>
				<!-- IE 2026 09 23 / ODOO-341407: i18n -->
				<button type="button" class="p-link p-link-topbar tb-right-more" ref="rightMore" v-uiHelp="'topbar.more'"
					:style="{ display: (rightHidden > 0 || hideLeft2 || hideRight2) ? '' : 'none' }"
					@click.stop="tbMoreTap" v-wjTooltip="t('More')">
					<i class="pi pi-ellipsis-v"></i>
				</button>
				<div class="topbar-right-overflow" v-if="rightMenuOpen" @click.stop>
					<!-- спрятанные меню рабочей области (Widgets/Calc/More) — IE 2026 11 02 / ODOO-349799 (workspace-wording) -->
					<!-- IE 2026 10 08 / ODOO-5800 (скрины Игоря, стол 2W1_001: «⋮» открывал не те формы, что кнопки широкой шапки): строки «⋮» — таблица overflowRows
					     (utils/topbarOverflow.js): тот же компонент и те же обработчики, что у кнопки широкой шапки (PagesPanel / MenuPanel с тем же *Bind / DatabasePicker);
					     kind 'wj' — прежние wj-menu (ПМ в обоих режимах; остальное — при выключенных панелях или fe.ux.topbarOverflowSameMenus = false) -->
					<div v-if="hideLeft2" class="topbar-overflow-menus workspace-menu">
						<template v-for="row in overflowLeftRows" :key="'ovl' + row.id">
							<div v-if="row.kind === 'pagesPanel'" class="topbar-right-overflow-item ovm-row ovm-same">
								<PagesPanel class="pages-menu" :openDelay="menuHoverMs" :hover="menuHoverMs > 0" icon="pi ie-ico-tabs" align="right" btnClass="p-link ovm-same-btn">
									<template #trigger><i class="pi ie-ico-tabs"></i><span>{{ t('Pages') }}</span></template>
								</PagesPanel>
							</div>
							<div v-else-if="row.kind === 'menuPanel' && row.id === 'page'" class="topbar-right-overflow-item ovm-row ovm-same">
								<!-- IE 2026 11 02 / ODOO-350449 (заказ Игоря: p214 єдине меню робочої області — вкладки Меню / Сторінки / Завдання): в «⋮» — та же форма меню рабочей области -->
								<WorkspaceMenuForm v-if="wsMenuTabsOn" class="page-menu-ws" :pageBind="pageMenuBind" :tasksBind="tasksPanelOn ? tasksMenuBind : null" :settingsItem="tasksSettingsItem" align="right" btnClass="p-link ovm-same-btn">
									<template #trigger><i class="pi ie-ico-menu-panel"></i><span>{{ t('Workspace menu') }}</span></template>
									<template #card="{ raw }"><WidgetPreviewImg :pic="pageMenuPicOf(raw)" :icon="pageMenuIconOf(raw)" :title="pageMenuTitleOf(raw)" :lay="pageMenuLayOf(raw)" :fill="false" /></template>
								</WorkspaceMenuForm>
								<MenuPanel v-else class="page-menu" v-bind="pageMenuBind" align="right" btnClass="p-link ovm-same-btn">
									<template #trigger><i class="pi ie-ico-menu-panel"></i><span>{{ t('Page menu') }}</span></template>
									<template #card="{ raw }"><WidgetPreviewImg :pic="pageMenuPicOf(raw)" :icon="pageMenuIconOf(raw)" :title="pageMenuTitleOf(raw)" :lay="pageMenuLayOf(raw)" :fill="false" /></template>
								</MenuPanel>
							</div>
							<div v-else-if="row.kind === 'menuPanel' && row.id === 'tasks'" class="topbar-right-overflow-item ovm-row ovm-same">
								<MenuPanel class="tasks-menu" v-bind="tasksMenuBind" align="right" btnClass="p-link ovm-same-btn">
									<template #trigger><i class="pi ie-ico-tasks-panel"></i><span>{{ t('Tasks') }}</span></template>
								</MenuPanel>
							</div>
							<template v-else-if="row.kind === 'wj'">
						<!-- IE 2026 08 20 / ODOO-336291 (mobile UX), скрин Игоря 21.08 09:02: пункты меню стола —
						     тот же формат, что и остальные пункты «⋮» (плитка-иконка + подпись) -->
						<div v-for="(menu, index) in menuTree" :key="'ovm' + index"
							class="topbar-right-overflow-item ovm-row" @click="ovmRowTap($event)">
							<i :class="menu.node?.pi || 'pi pi-th-large'"></i>
							<wj-menu
								:header="menu.node?.valueStr"
								:displayMemberPath="'node.valueStr'"
								:subItemsPath="'attrs'"
								:showDropDownButton="false"
								:openOnHover="!store.mobileUi?.on"
								:isAnimated="false"
								:itemsSource="menu.attrs"
								:initialized="initMenu"
								:itemClicked="menuNodeClicked" :formatItem="store.formatMenuItem"
							/>
						</div>
							</template>
						</template>
					</div>
					<button v-for="a in rightOverflowActions" :key="a.action" type="button"
						class="topbar-right-overflow-item" @click="runRightAction(a); rightMenuOpen = false" v-uiHelp="'topbar.right.' + a.action">
						<i :class="a.icon"></i><span>{{ a.label }}</span>
					</button>
					<!-- спрятанные база / процессная модель / пользователь -->
					<!-- IE 2026 10 08 / ODOO-5800: строки overflowRows — база: тот же DatabasePicker (toggleDbPicker), пользователь: та же панель «User menu» (userMenuBind); ПМ — wj-menu, как в широкой шапке -->
					<div v-if="hideRight2" class="topbar-overflow-menus">
						<template v-for="row in overflowRightRows" :key="'ovr' + row.id">
							<div v-if="row.kind === 'dbPicker'" class="layout-flex-center workspace-title-1 db-chip-wrap ovm-row ovm-same" v-uiHelp="'topbar.db'">
								<a class="db-chip ovm-same-btn" @click.stop="toggleDbPicker"><i class="logo_pi pi pi-database"></i>{{ store.user.database.title }}</a>
								<div v-if="dbPickerVisible" class="db-picker-popup" ref="dbPickerBox" @click.stop>
									<DatabasePicker ref="dbPicker" mode="popup" :currentDbid="store.user.database?.dbid || ''" :adminInfo="true" @select="onDbPicked" />
								</div>
							</div>
							<div v-else-if="row.id === 'db'" class="layout-flex-center workspace-title-1">
								<i class="logo_pi pi pi-database"></i>
								<wj-menu :header="store.user.database.title" :displayMemberPath="'title'" :subItemsPath="'attrs'" :showDropDownButton="false"
									dropDownCssClass="rail-style-menu"
									:openOnHover="!store.mobileUi?.on" :isAnimated="false" :itemsSource="store.database_attrs" :initialized="initMenu" :itemClicked="menuNodeClicked" :formatItem="store.formatMenuItem"
								/>
							</div>
							<div v-else-if="row.id === 'pm'" class="layout-flex-center workspace-title-1">
								<i :class="['logo_pi', 'pi', pmIcon]"></i><!-- IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): значок открытой модели (архив — свой) -->
								<PmMenuPanel v-if="pmMenuFormOn && overflowSame" :header="pmMenuHeader" :btnClass="[pmBtnClass, 'ovm-same-btn']" :hoverMs="menuHoverMs" /><!-- IE 2026 10 26 / ODOO-pending (заказ Игоря 26.10: меню процессной модели — форма меню с группировкой) -->
								<wj-menu v-else :header="pmMenuHeader" :displayMemberPath="'title'" :subItemsPath="'attrs'" :showDropDownButton="false"
									:openOnHover="!store.mobileUi?.on" :isAnimated="false" :itemsSource="pmMenuFlat" :initialized="initMenu" :itemClicked="menuNodeClicked" :formatItem="store.formatMenuItem"
								/>
							</div>
							<div v-else-if="row.kind === 'menuPanel'" class="layout-flex-center workspace-title-1 ovm-row ovm-same">
								<MenuPanel v-bind="userMenuBind" btnClass="p-link user-menu-btn ovm-same-btn">
									<template #trigger><i class="logo_pi pi pi-user"></i><span class="user-menu-title">{{ store.user.title }}</span></template>
								</MenuPanel>
							</div>
							<div v-else-if="row.kind === 'wj'" class="layout-flex-center workspace-title-1">
								<i class="logo_pi pi pi-user"></i>
								<wj-menu :header="store.user.title" :displayMemberPath="'title'" :subItemsPath="'attrs'" :showDropDownButton="false"
									:openOnHover="!store.mobileUi?.on" :isAnimated="false" :itemsSource="user_menu" :initialized="initMenu" :itemClicked="menuNodeClicked" :formatItem="store.formatMenuItem"
								/>
							</div>
						</template>
					</div>
				</div>
			</div>

<!-- IE 2026 08 20 / ODOO-336291 (mobile UX), заказ Игоря 21.08: глобальное меню «⋮» —
     тот же движок, что рейл-меню страниц/виджетов/табов, у правого верхнего угла;
     подменю — навигация вглубь, строка со стрелкой возвращает назад -->
<teleport to="body" v-if="store.mobileUi?.on && mobileMenu">
	<div class="mobile-tabs-backdrop" @click.stop="mobileMenu = null"></div>
	<div class="mobile-tabs-list mobile-menu-right" :class="{ 'mm-deep': mobileMenu.stack.length > 1 }" @click.stop>
		<!-- IE 2026 09 23 / ODOO-341407: i18n -->
		<div class="mobile-list-title">{{ t('Menu') }}</div>
		<!-- IE 2026 08 22 (заказ Игоря 12:0x): INLINE-раскрытие — дети выпадают под
		     пунктом с отступом по глубине; стрелка вправо/вниз в белом круге -->
		<div class="mobile-tabs-row mm-row" v-for="(node, i) in mmFlat" :key="i"
			:style="{ marginLeft: (node.depth * 22) + 'px' }" @click.stop="mmTap(node.it)">
			<span v-if="node.folder" class="mt-label mm-folder-btn">
				<i v-if="node.pi" :class="node.pi"></i>
				<span class="mm-folder-text">{{ node.title }}</span>
				<i class="pi mm-chev" :class="node.it._open ? 'pi-angle-down' : 'pi-angle-right'"></i>
			</span>
			<template v-else>
				<span class="mt-icon"><i :class="node.pi || 'pi pi-circle'"></i></span>
				<span class="mt-label">{{ node.title }}</span>
			</template>
		</div>
	</div>
</teleport>

<div class="topbar-right-2" ref="right2" :style="{ display: hideRight2 ? 'none' : '' }">
				<li class="layout-flex-center workspace-title-1 db-chip-wrap">
					<i class="logo_pi pi pi-database" v-uiHelp="'topbar.db'"></i> <!--@click="frmEditAccountPopup.show(true)"-->
					<!-- DB switcher popup (ODOO-3483): log-widget-style picker (search,
					     company groups, my/all) instead of the plain wj-menu list -->
					<a class="db-chip" v-if="store.user.database && 'title' in store.user.database" @click.stop="toggleDbPicker" v-uiHelp="'topbar.db'">
						{{ store.user.database.title }}
					</a>
					<!-- IE 2026 10 08 / ODOO-5800: при свёрнутой правой части (hideRight2) та же всплывашка живёт в строке «⋮» (те же ref) -->
					<div v-if="dbPickerVisible && !(hideRight2 && overflowSame)" class="db-picker-popup" ref="dbPickerBox" @click.stop>
						<DatabasePicker ref="dbPicker" mode="popup"
							:currentDbid="store.user.database?.dbid || ''"
							:adminInfo="true"
							@select="onDbPicked"
						/>
					</div>
				</li>

				<li class="layout-flex-center workspace-title-1">
					<i 
						:class="{
							['logo_pi pi ' + pmIcon]: true,
							'pm-archive-icon': pmIcon !== 'pi-sitemap',
							'no-current-process_model': store.process_model_current &&
														store.process_model_current !== store.process_model_record?.id
						}"
					 v-uiHelp="{ key: 'topbar.pm', state: () => (store.process_model_current && store.process_model_current !== store.process_model_record?.id ? 'notCurrent' : 'current') }"></i>
					<!-- <span><div class="process-model-title">{{ store.process_model_record?.title||'' }}</div></span> -->

					<!-- IE 2026 10 26 / ODOO-pending (заказ Игоря 26.10: меню процессной модели — форма меню с группировкой): форма меню; прежний список — при fe.ux.pmMenuForm = false -->
					<PmMenuPanel v-if="pmMenuFormOn" :header="pmMenuHeader" :btnClass="pmBtnClass" :hoverMs="menuHoverMs" />
					<wj-menu v-else id="menu_pm" :header="pmMenuHeader" v-uiHelp="{ key: 'topbar.pm', state: () => (store.process_model_current && store.process_model_current !== store.process_model_record?.id ? 'notCurrent' : 'current') }" :displayMemberPath="'title'" :subItemsPath="'attrs'" :showDropDownButton="false"
						:openOnHover="!store.mobileUi?.on" :isAnimated="false" :itemsSource="pmMenuFlat" :initialized="initMenu" :itemClicked="menuNodeClicked" :formatItem="store.formatMenuItem"
						:class="{
							'process-model-title': true,
							'no-current-process_model': store.process_model_current &&
														store.process_model_current !== store.process_model_record?.id
						}"
					/>
				</li>

				<li class="layout-flex-center workspace-title-1">
					<i class="logo_pi pi pi-user"></i>
					<!-- IE 2026 09 22 / ODOO-… (предложение Игоря, шаг 2): меню пользователя — панель функций в стиле 1С (папки Color scheme / Filters / Widgets / Page… — группы,
					     команды между разделителями — группы без заголовка); прежнее wj-menu — мобильный профиль / выключатель fe.ux.menuPanelUser -->
					<!-- IE 2026 09 23 / ODOO-341407: i18n -->
					<!-- IE 2026 09 24 / ODOO-… (заказ Игоря: заголовок панелей-меню): ряд «User menu · пользователь» (иконка ряда — pi-user, как у кнопки) -->
					<!-- IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt): help — вид панели для объяснений элементов по Alt (utils/uiHelp/menuPanel.js) -->
					<!-- IE 2026 10 08 / ODOO-5800 (скрины Игоря: «Igor» в «⋮» открывал прежнее контекстное меню): свойства и обработчики панели — одна таблица userMenuBind, та же у строки «⋮» -->
					<MenuPanel v-if="store.menuPanel_on('User')" v-bind="userMenuBind" btnClass="p-link user-menu-btn">
						<template #trigger><span class="user-menu-title">{{ store.user.title }}</span></template>
					</MenuPanel>
					<wj-menu v-else id="menu_1" :header="store.user.title" v-uiHelp="'topbar.user.fallback'" :displayMemberPath="'title'" :subItemsPath="'attrs'" :showDropDownButton="false"
						:openOnHover="!store.mobileUi?.on" :isAnimated="false" :itemsSource="user_menu" :initialized="initMenu" :itemClicked="menuNodeClicked" :formatItem="store.formatMenuItem"
					/>
				</li>
			</div>
		</div>

		<!-- Debug backend panel (ODOO-3178) -->
		<!-- IE 2026 09 23 / ODOO-341407: i18n -->
		<Dialog v-model:visible="debugDialog.visible" modal :header="t('Debug backend')" :style="{ width: '560px', maxWidth: '95vw' }">
			<div v-if="debugDialog.loading" class="debug-panel">{{ t('Resolving backend…') }}</div>
			<div v-else-if="debugDialog.error && !debugDialog.info" class="debug-panel debug-err">{{ debugDialog.error }}</div>
			<div v-else-if="debugDialog.info" class="debug-panel">
				<div class="debug-row"><b>{{ t('Container:') }}</b> {{ debugDialog.info.container_name }}
					<span class="debug-muted">{{ t('(node {node}, env {env}, {count} DB)', { node: debugDialog.info.host_system, env: debugDialog.info.environment || '—', count: debugDialog.info.db_count }) }}</span></div>
				<div class="debug-row"><b>{{ t('Status:') }}</b>
					<span :class="debugDialog.info.debug_active ? 'debug-on' : 'debug-off'">{{ debugDialog.info.debug_active ? t('Debug ON') : t('Debug OFF') }}</span></div>
				<div class="debug-row" v-if="debugDialog.info.repo_path"><b>{{ t('Repo:') }}</b> <code>{{ debugDialog.info.repo_path }}</code><span v-if="debugDialog.info.branch"> @ {{ debugDialog.info.branch }}</span></div>

				<div v-if="debugDialog.info.is_shared_prod" class="debug-guard">
					{{ tn(debugDialog.info.db_count, '⚠ A dedicated debug container is required. This database runs on a shared/production backend ({n} tenant) — switching to debug would affect others. A dedicated debug container is provided on a separate request.', '⚠ A dedicated debug container is required. This database runs on a shared/production backend ({n} tenants) — switching to debug would affect others. A dedicated debug container is provided on a separate request.') }}
				</div>

				<div v-if="debugDialog.info.vscode_deeplink" class="debug-row debug-linkrow">
					<a :href="debugDialog.info.vscode_deeplink" v-uiHelp="'topbar.debug.vscode'">{{ t('Open in VS Code (Remote-SSH)') }}</a>
					<button class="debug-copy" @click="copyText(debugDialog.info.vscode_deeplink)" v-uiHelp="'topbar.debug.copy'">{{ t('copy') }}</button>
				</div>
				<div v-if="debugDialog.info.vscode_deeplink" class="debug-muted debug-hint">
					{{ t('The deep-link uses your host SSH configuration ({host}, user {user}, port {port}).', { host: debugDialog.info.host, user: debugDialog.info.ssh_user, port: debugDialog.info.ssh_port }) }}
				</div>

				<div v-if="debugDialog.info.ssh_tunnel_cmd" class="debug-row">
					<b>{{ t('SSH tunnel:') }}</b> <code class="debug-tunnel">{{ debugDialog.info.ssh_tunnel_cmd }}</code>
					<button class="debug-copy" @click="copyText(debugDialog.info.ssh_tunnel_cmd)">{{ t('copy') }}</button>
				</div>

				<div v-if="debugDialog.busy" class="debug-muted debug-busy">{{ t('Switching… (container re-creation, up to ~1–2 min)') }}</div>
				<div v-if="debugDialog.note" class="debug-muted debug-busy">{{ debugDialog.note }}</div>
				<div v-if="debugDialog.error && debugDialog.info" class="debug-err debug-footer-err">{{ debugDialog.error }}</div>
			</div>
			<template #footer>
				<button v-if="debugDialog.info && debugDialog.info.debug_active" class="debug-btn debug-btn-primary" :disabled="debugDialog.busy" @click="debugToggle(false)" v-uiHelp="{ key: 'topbar.debug.toggle', state: () => (debugDialog.info?.debug_active ? 'on' : 'off') }">{{ t('Disable debug') }}</button>
				<button v-else-if="debugDialog.info && debugDialog.info.can_enable_debug" class="debug-btn debug-btn-primary" :disabled="debugDialog.busy" @click="debugToggle(true)" v-uiHelp="{ key: 'topbar.debug.toggle', state: () => (debugDialog.info?.debug_active ? 'on' : 'off') }">{{ t('Enable debug') }}</button>
				<button class="debug-btn" @click="debugDialog.visible=false">{{ t('Close') }}</button>
			</template>
		</Dialog>

	</div>
</template>

<script>
import freeWidgets from './utils/freeWidgets' // IE 2026 09 08 / ODOO-… (заказ Игоря): меню Widgets → Behavior
// import 'bootstrap.css';
import { useMainStore, COLOR_SCHEMES, ICON_SCHEMES, IS_NEW_INFRA } from './stores/mainStore' // IE 2026 09 14 / ODOO-… (заказ Игоря: схемы иконок): ICON_SCHEMES
import { getLanguage, enabledLanguages as i18n_enabledLanguages, t, tn } from '@/i18n' // IE 2026 09 23 / ODOO-341407: подменю выбора языка интерфейса; t/tn — i18n строк шапки; IE 2026 09 26 / ODOO-341407: только включённые в базе языки
import * as input from '@mescius/wijmo.input';
import DatabasePicker from './components/DatabasePicker.vue'
import { tasksPanel_flatten, tasksPanel_errors, tasksPanel_openAction, tasksPanel_favKey, tasksPanel_segments, tasksPanel_withSettings } from '@/utils/tasksPanel' // IE 2026 09 23 / ODOO-… (заказ Игоря: панель задач в шапке)
import { settingsPage_on, settingsPage_available, settingsPage_title, SETTINGS_PAGE_ID } from '@/utils/settingsPage'   // IE 2026 10 28 / ODOO-5800 (заказ Игоря: страница настроек стола — из меню задач, не из списка страниц)
import { wsTaskLabel_title } from '@/utils/wsTaskLabel'   // IE 2026 10 29 / ODOO-5800 (слово Igor 29.10: «задание рабочего стола и далее название этого стола»)
import { navigator_on } from '@/utils/navigator'   // demo-webscm 2026 11 02 / ODOO-350612: кнопка «Навігатор» и флажок «Open navigator at start»
import { helpCard_on, helpCard_show } from '@/utils/helpCard'   // IE 2026 11 03 / ODOO-350881 (инвентаризация помощи, этап 1): «?» страницы и рабочей области
import MenuPanel from './components/MenuPanel.vue' // IE 2026 09 22 / ODOO-… (предложение Игоря): панель функций страницы в стиле 1С
import { pmMenu_foldArchivesFlat, pmMenu_recTitle, pmMenu_recIcon } from '@/utils/pmMenuGroups' // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ)
import PmMenuPanel from './components/PmMenuPanel.vue' // IE 2026 10 26 / ODOO-pending (заказ Игоря 26.10: меню процессной модели — форма меню с группировкой)
import { menuParam_has, menuParams_on } from '@/utils/menuParams' // IE 2026 10 06 / ODOO-341407 (заказ Игоря п.3.2): строки-списки меню пользователя — звезда избранного
import WorkspaceMenuForm from './components/WorkspaceMenuForm.vue'   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p214 єдине меню робочої області — вкладки Меню / Сторінки / Завдання)
import PagesPanel from './components/PagesPanel.vue' // IE 2026 09 26 / ODOO-… (заказ Игоря: виды панели страниц): панель страниц стола целиком (у любого триггера)
import WidgetPreviewImg from './components/WidgetPreviewImg.vue' // IE 2026 09 27 / ODOO-… (заказ Игоря: картинки виджетов): карточки меню страницы — картинки виджетов
import { widgetPreviews_ready, widgetPreviews_load, widgetPreviews_picOfRow, widgetPreviews_updatePage, wpLayOf, wpRowWidget, wpState } from '@/utils/widgetPreviews' // IE 2026 09 27 / ODOO-… (заказ Игоря: картинки виджетов)
import { menuTipPreview_widget } from '@/utils/menuTipPreview' // IE 2026 10 04 / ODOO-345046 (заказ Игоря: превью в Alt-подсказке пунктов меню)
import { topbarOverflowSame_on, topbarOverflowRows } from '@/utils/topbarOverflow' // IE 2026 10 08 / ODOO-5800: строки «⋮» — те же формы, что у кнопок широкой шапки
import { importRecordsMenu_on } from '@/utils/importRecords' // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: импорт записей — меню и вставка): пункт «Import records» (fe.ux.importRecordsMenu)
import { pageSchema_icon } from '@/utils/pageSchema' // IE 2026 09 27 / ODOO-… (заказ Игоря: картинки виджетов): значок карточки без картинки

export default {
	props: {
		menuOpen: { type: Boolean, default: false },
		hoverLock: { type: Boolean, default: false },   // IE 2026 10 29 / ODOO-5800 (заказ Игоря 29.10: кнопка «закрыть список столов» на месте кнопки шапки — без повторного открытия наведением): список закрыт кнопкой в его заголовке, курсор стоит на кнопке шапки — наведение не открывает список до ухода мыши с кнопки   // IE 2026 10 29 / ODOO-5800 (заказ Игоря 29.10: иконка панели столов — «panel-left» с состоянием открыто/закрыто; «Страницы» в шапке — глиф вкладок): панель списка столов открыта (App.vue sidebarOpen) — глиф кнопки столов и состояние объяснения
	},
	data: () => ({
		frmEditAccountPopup: {},
		pw3: '',
		pw4: '',
		chipsMultiRow: false,
		rightHidden: 0,      // сколько правых иконок свёрнуто в «⋮»
		rightMenuOpen: false,
		mobileMenu: null, // IE 2026 08 20 / ODOO-336291 (mobile UX), 21.08: рейл-лист «⋮»
		hideLeft2: false,    // меню Widgets/Calc/More свёрнуто в «⋮»
		hideRight2: false,   // база/процессная модель/пользователь свёрнуты в «⋮»
		debugDialog: { visible: false, loading: false, busy: false, error: '', note: '', info: null },
		dbPickerVisible: false,
		alarmAckByWs: {},   // workspace id -> диалог сигнализации уже показан/закрыт
		pageMenuViewId: 'list',   // IE 2026 09 27 / ODOO-… (заказ Игоря: картинки виджетов): вид меню страницы — list | previews (localStorage pageMenuView:<пользователь>:<база>)
	}),
	computed: {
		// IE 2026 10 29 / ODOO-5800 (заказ Игоря 29.10: иконка панели столов — «panel-left» с состоянием открыто/закрыто; «Страницы» в шапке — глиф вкладок): объяснение кнопки столов по Alt — с состоянием панели (open / closed), читается в момент показа
		wsBtnHelp() { return { key: 'topbar.menuToggle', state: () => (this.menuOpen ? 'open' : 'closed') } },
		darkTheme() {
			return this.$appState.darkTheme;
		},
		isAdmin() {
			return this.store.checkAccess({ viewAccess: 'access-admin' });
		},
		// сигнализация стола: doc.params.workspace_alarm пишет бэкенд
		// (log.scan_alarm — критические задачи с ошибкой/зависшие в ожидании);
		// показывается только администраторам
		workspaceAlarm() {
			const al = this.store.activeWORKSPACE?.record?.doc?.params?.workspace_alarm
			if (!al || !al.count || !this.isAdmin) return null
			// workspace_alarm лежит в СОХРАНЁННЫХ params записи стола: без отметки
			// свежести показывался залипший снимок — задача давно не critical или уже
			// отработала, а диалог всплывал при каждом входе (dev02: 'Update fts',
			// лог 03.08, critical снят). Снимок старше ALARM_MAX_AGE_MIN игнорируем —
			// покажется заново, когда бэк пересчитает задачи (scan_alarm).
			const ALARM_MAX_AGE_MIN = this.store?.setting?.('fe.polling.alarmMaxAgeMin', 30) ?? 30   // IE 2026 09 05 / ODOO-336330
			if (!al.scanned_at) return null // старый формат без отметки — не доверяем
			const t = Date.parse(al.scanned_at + (/[Zz+]|\d{2}:\d{2}$/.test(al.scanned_at.slice(10)) ? '' : 'Z'))
			if (!t || (Date.now() - t) / 60000 > ALARM_MAX_AGE_MIN) return null
			return al
		},
		alarmDialogVisible() {
			const ws = this.store.activeWORKSPACE?.workspace
			return !!(this.workspaceAlarm && ws && !this.alarmAckByWs[ws])
		},
		isDeveloper() {
			// access-developer || access-admin (checkAccess falls back to admin)
			return this.store.checkAccess({ viewAccess: 'access-developer' });
		},
		// IE 2026 09 22 / ODOO-… (предложение Игоря): панель функций страницы вместо выпадающих меню — настройка fe.ux.pageMenuPanel
		// (по умолчанию вкл.); мобильный профиль остаётся на прежних меню (они там и так свёрнуты в «⋮»)
		// IE 2026 09 22 / ODOO-… (заказ Игоря, п.5): панель страниц — на заголовке в шапке (не в мобильном профиле); fe.ux.pagesMenuOnTitle = false — прежняя иконка
		pagesOnTitle() {
			return this.pageMenuPanelOn && !this.store.mobileUi?.on && this.store.setting('fe.ux.pagesMenuOnTitle', true) !== false && !this.pagesOnRailToggle   // IE 2026 09 26 / ODOO-… (замечания Игоря: рейл и шапка) (п. 3.2)
		},
		// IE 2026 09 26 / ODOO-… (замечания Игоря: рейл и шапка) (п. 3.2): панель страниц — на кнопке рейла (store.pagesPanel_onRailToggle: fe.ux.pagesPanelOnRailToggle, одно правило с Page.vue)
		pagesOnRailToggle() { return !!this.store.activeWORKSPACE && !!this.store.pagesPanel_onRailToggle() },
		// IE 2026 10 03 / ODOO-345044 (заказ Игоря: кнопка «Страницы» в шапку, hover-меню с задержкой, скрытие рейки кнопкой в меню): кнопка «Страницы» в шапке — режим (fe.ux.pagesButtonInTopbar, одно правило со стором и Page.vue) и сама кнопка (рейл есть: страниц больше одной);
		// пауза наведения форм-меню шапки (fe.ux.menuHoverOpenMs); класс кнопки — приглушена, пока рейл скрыт
		pagesBtnMode() { return !!this.store.activeWORKSPACE && !!this.store.pagesButtonInTopbar_on() },
		pagesInTopbar() { return this.pagesBtnMode && Object.keys(this.store.activeWORKSPACE.PAGES || {}).length > 1 && !this.wsMenuTabsOn },   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p214 єдине меню робочої області — вкладки Меню / Сторінки / Завдання): с формой меню рабочей области кнопки «Страницы» нет — страницы во вкладке Pages формы и в пункте «All pages…» рейла
		wsMenuTabsOn() { return !!this.store.activeWORKSPACE && !!this.store.workspaceMenuTabs_on() },
		wsMenuOnTitle() { return this.wsMenuTabsOn && !!this.store.workspaceMenuOnTitle_on() },   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p225 єдине меню робочої області, етап 2): форма меню рабочей области — на названии стола (fe.ux.workspaceMenuOnTitle)   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p214 єдине меню робочої області — вкладки Меню / Сторінки / Завдання)
		pagesTopbarBtnClass() { return 'p-link p-link-topbar pages-menu-btn pages-topbar-btn' + (this.store.pagesRailHidden ? ' rail-toggle-hidden' : '') },
		menuHoverMs() { return this.store.menuHoverOpenMs() },
		// IE 2026 10 13 / ODOO-345044 (заказ Игоря 13.10, скрин DM «Завдання»: «эту форму меню показывать только при клике, а не при ховере»): панель задач
		// (по заголовку стола и по кнопке шапки) открывается только кликом; наведение — лишь при fe.ux.tasksMenuHover = true (и общей паузе > 0)
		tasksMenuHover() { void this.store._settingsEpoch; return this.menuHoverMs > 0 && this.store.setting('fe.ux.tasksMenuHover', false) === true },
		// IE 2026 09 24 / ODOO-… (заказ Игоря: заголовок панелей-меню): подзаголовки панелей шапки — «к чему относится меню»: стол (панели страниц и задач),
		// текущая страница (меню страницы); реактивны к смене стола / страницы (activeWORKSPACE / activePAGE — как titleTopBar)
		menuSub_workspace() { const WS = this.store.activeWORKSPACE; return WS ? String(WS.titleTopBar || WS.title || WS.workspace || '') : '' },
		menuSub_page() { const P = this.store.activeWORKSPACE?.activePAGE; return P ? String(P.title || P.tooltip || (P.node && P.node.valueStr) || '') : '' },
		// IE 2026 09 23 / ODOO-… (заказ Игоря: панель задач в шапке): только администраторам (store.checkAccess access-admin — как сигнализация стола) и при
		// включённой панели (fe.ux.menuPanelTasks через menuPanel_on; мобильный профиль — нет). Строки — снимок статусов стора (tasksBar_rows: свежий скан
		// log.scan_log_multi, иначе запись стола, как пришла со столом); пункты — общий модуль utils/tasksPanel.js (тот же, что у вкладки Tasks panel формы
		// стола); бейдж — число задач (уникальных узлов-ссылок) со статусом последнего запуска STATUS-error
		// IE 2026 09 26 / ODOO-… (замечания Игоря: рейл и шапка) (п. 3.3): панель задач — ВСЕМ пользователям (fe.ux.tasksPanelAllUsers; false — только администраторам, как было): не-администратор видит
		// то же дерево задач стола, клик открывает запись задачи (widget_open — ничего не запускает; START в форме бэк не ограничивает правом администратора)
		tasksAllUsers() { return this.store.setting('fe.ux.tasksPanelAllUsers', true) !== false },
		tasksPanelOn() { return !!this.store.activeWORKSPACE && (this.isAdmin || this.tasksAllUsers) && this.store.menuPanel_on('Tasks') },
		// IE 2026 09 26 / ODOO-… (замечания Игоря: рейл и шапка) (п. 3.3): панель задач — на названии стола, когда название свободно от панели страниц (fe.ux.tasksPanelOnTitle)
		tasksOnTitle() { return this.tasksPanelOn && !this.pagesOnTitle && !this.wsMenuOnTitle && this.store.setting('fe.ux.tasksPanelOnTitle', true) !== false },   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p225 єдине меню робочої області, етап 2): название занято формой меню рабочей области
		tasksWs() { return this.store.activeWORKSPACE?.workspace || '' },
		tasksRecord() { return this.store.activeWORKSPACE?.record || null },
		tasksRows() { return this.tasksWs ? this.store.tasksBar_rows(this.tasksWs) : [] },
		tasksPanelItems() {
			void this.store.itemsSource_change_index   // словари STATUS / SEGMENTS приходят позже строк — названия статусов и значки
			return tasksPanel_withSettings(tasksPanel_flatten(this.tasksRows, this.tasksCtx()), this.tasksSettingsItem)   // IE 2026 10 28 / ODOO-5800 (заказ Игоря: страница настроек стола — из меню задач, не из списка страниц)
		},
		// IE 2026 10 28 / ODOO-5800 (заказ Игоря: страница настроек стола — из меню задач, не из списка страниц): пункт «страница настроек стола» первой группой меню задач — есть шаблон бэка WORKSPACE.settings_page
		// (только администратору) или страница ещё в списке страниц стола; выключатель fe.ux.settingsPageInMenu (false — пункта нет, как было)
		tasksSettingsItem() {
			void this.store._settingsEpoch
			const WS = this.store.activeWORKSPACE
			if (!WS || !settingsPage_on(this.store) || !settingsPage_available(WS)) return null
			return {
				on: true, groupTitle: t('Workspace'), title: wsTaskLabel_title(this.store, WS, { _settingsPage: true }, settingsPage_title(WS, t('Tasks & Workspace settings')), getLanguage(), t),   // IE 2026 10 29 / ODOO-5800 (слово Igor 29.10: «задание рабочего стола и далее название этого стола»): «Workspace task: <название стола>»; fe.ux.wsTaskLabel = false — как было
				tooltip: t('Open the task tree and settings of this workspace as a temporary page (added at the end of the page list, not saved)'),
				active: WS.active_page === SETTINGS_PAGE_ID,
			}
		},
		tasksErrors() { return tasksPanel_errors(this.tasksRows, this.tasksCtx()) },   // IE 2026 09 23 (заказ Игоря: панель задач в шапке — названия): названия задач с ошибкой
		tasksErrBadge() {
			const n = this.tasksErrors.count
			if (!n) return null
			return { text: String(n), cls: 'is-bad', title: tn(n, '{n} task failed on its last run', '{n} tasks failed on their last run') }
		},
		// IE 2026 11 03 / ODOO-350449 (заказ Игоря: p225 єдине меню робочої області, етап 2 — «при наведении на бэч … и удержании альта надо подробно говорить, что это такое»): бейдж у названия стола с формой меню рабочей области —
		// тот же счёт (tasksErrBadge), объяснение по Alt topbar.tasksBadge: число, названия задач (первые пять), когда прочитаны статусы
		wsTitleBadge() {
			const b = this.tasksPanelOn ? this.tasksErrBadge : null
			if (!b) return null
			return { ...b, help: { key: 'topbar.tasksBadge', vars: () => {
				const e = this.tasksErrors, names = ((e && e.rows) || []).map(r => r.title).filter(Boolean)
				return { n: (e && e.count) || 0, names: names.slice(0, 5).join(', ') + (names.length > 5 ? ', …' : ''), readAt: this.tasksRefreshNow || '' }
			} } }
		},
		tasksFavKey() { return tasksPanel_favKey(this.tasksRecord?.id) },
		tasksPanelBusy() { return !!this.store.tasksBar_state(this.tasksWs)?.loading },
		tasksPanelTooltip() {
			const n = this.tasksErrors.count
			const base = t('Tasks of this workspace: the task tree with the status of the last run (hover or click); the red badge counts the tasks whose last run failed')
			return n ? base + ' — ' + tn(n, '{n} task failed on its last run', '{n} tasks failed on their last run') : base
		},
		// IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt): данные объяснений панели задач — число задач с ошибкой последнего запуска, их названия (первые три), когда прочитаны статусы
		tasksHelpVars() {
			const e = this.tasksErrors, names = ((e && e.rows) || []).map(r => r.title).filter(Boolean)
			return { errors: (e && e.count) || 0, failed: names.slice(0, 3).join(', ') + (names.length > 3 ? ', …' : ''), refreshNow: this.tasksRefreshNow, onTitle: this.tasksOnTitle, allUsers: this.tasksAllUsers }   // IE 2026 09 26 / ODOO-… (замечания Игоря: рейл и шапка) (п. 3.3)
		},
		tasksRefreshNow() {
			const st = this.store.tasksBar_state(this.tasksWs)
			if (st && st.loading) return t('Reading…')
			if (st && st.at) { try { return t('Statuses read at {time}', { time: new Date(st.at).toLocaleTimeString() }) } catch (e) { /* время не разобрано */ } }
			return t('Statuses have not been read yet')
		},
		tasksRefreshTitle() {
			const st = this.store.tasksBar_state(this.tasksWs)
			if (st && st.at) { try { return t('Refresh the task statuses (read at {time})', { time: new Date(st.at).toLocaleTimeString() }) } catch (e) { /* время не разобрано */ } }
			return t('Refresh the task statuses')
		},
		// IE 2026 09 27 / ODOO-… (заказ Игоря: картинки виджетов): меню страницы — переключатель видов List / Widget previews и кнопка «Update page previews»; есть, когда бэк подтвердил методы картинок
		// (widgetPreviews_ready: не мобильный профиль, fe.ux.widgetPreviews); иначе — прежний список
		pageMenuPreviewsOn() { void wpState.epoch; return widgetPreviews_ready(this.store) },
		pageMenuViews() {
			if (!this.pageMenuPreviewsOn) return null
			return [{ id: 'list', icon: 'pi pi-list', label: t('List'), help: 'menuPanel.view.list' }, { id: 'previews', icon: 'pi pi-th-large', label: t('Widget previews'), help: 'menuPanel.view.widgetPreviews' }]
		},
		pageMenuViewCur() { return (this.pageMenuPreviewsOn && this.pageMenuViewId === 'previews') ? 'previews' : 'list' },
		pageMenuTools() {
			if (!this.pageMenuPreviewsOn) return null
			const run = wpState.pageRun
			return [{ id: 'previewsUpdate', icon: run ? 'pi pi-stop-circle' : 'pi pi-camera', label: run ? t('Stop updating previews') : t('Update page previews'), on: !!run, help: 'menuPanel.previewsUpdate' }]
		},
		pageMenuPanelOn() {
			return this.store.menuPanel_on('Page')   // IE 2026 09 22 / ODOO-… (предложение Игоря, шаг 2): выключатели в сторе (fe.ux.menuPanel, fe.ux.menuPanelPage)
		},
		// IE 2026 09 22 / ODOO-… (предложение Игоря, шаг 2): блок Commands в панели страницы Игорь по скрину снял — панель = группы меню страницы
		menuTree() {
			// IE 2026 10 01 / ODOO-5800 (слово Игоря): у варианта страницы меню — ОСНОВНОЙ страницы (store.variantMenu_rows; набор открытия — из варианта).
			// Выключатель fe.ux.variantMenuFromMain=false — строки самой страницы, как было
			const WS = this.store.activeWORKSPACE
			const rows = (WS && this.store.variantMenu_rows) ? this.store.variantMenu_rows(WS, WS.active_page) : (WS?.activePAGE?.attrs||[])
			// IE 2026 09 16 / ODOO-… (замечание Игоря): меню шапки страницы = группы строк (Widgets, Calc, More…);
			// строки-виджеты верхнего уровня (вариант страницы / страница, сохранённые плоским списком) собираются
			// в одно меню «Widgets» на месте первой из них — как у страницы с группой, а не по меню на каждый виджет
			const isWidget = (row) => !!(row && (row.widget || row.node?.relation_segment))
			if (!rows.some(isWidget)) return rows
			const out = []
			let group = null
			for (const row of rows) {
				if (!isWidget(row)) { out.push(row); continue }
				if (!group) {
					group = { node: { value: 'Widgets', valueStr: t('Widgets'), attr_type: 'AttrStr', pi: 'pi pi-th-large' }, attrs: [], _synthetic: true }   // IE 2026 09 23 / ODOO-341407: i18n
					out.push(group)
				}
				group.attrs.push(row)
			}
			return out
		},
		activeChipsCount() {
			return (this.store.activeWORKSPACE?.record?.doc?.params?.WHERE ?? [])
				.filter(item => item.use !== false).length;
		},
		topbarChipsAttr() {
			const ws = this.store.activeWORKSPACE
			if (!ws || (this.store.chipsBarPosition ?? 'topbar') !== 'topbar') return null
			return {
				attr_type: 'AttrChips',
				binding: 'WORKSPACE.record.doc.params.WHERE',
				placeholder: t('Selectors…'),   // IE 2026 09 23 / ODOO-341407: i18n
				// chipMapping: {
				// 	use: 'use',
				// 	cssClass: 'leftValue.value',
				// 	defaults: {
				// 		pi: 'pi-filter',
				// 		segment: 'CHIP-Selector',
				// 	}
				// }
			}
		},
		titleTopBar() {
			const wsTitle = this.store.activeWORKSPACE.activePAGE?.title || this.store.activeWORKSPACE.activePAGE?.tooltip || ''
			if (this.showMenuToggle) {
				const titlePage = Object.keys(this.store.activeWORKSPACE?.PAGES || '').length > 1 ? ` / ${wsTitle}` : ''
				const titleWorkspace = this.store.activeWORKSPACE?.titleTopBar || this.store.activeWORKSPACE?.title
				return titleWorkspace // + titlePage
			} else {
				return wsTitle
			}
		},
		user_menu() {   // IE 2026 09 23 / ODOO-341407: i18n — подписи через t(); _key — английский ключ пункта для поиска по названию в user_menu_panel (byTitle)
            const items0_all = [   // IE 2026 09 29 / ODOO-342781: было items0 — для роли «только чтение» список фильтруется ниже (см. items0)
                { 'title': t('My profile'), cssClass:'pi pi-wrench', 'command': 'onOpenMyProfile__Click' },
                ...(IS_NEW_INFRA ? [{ 'title': t('Sign-in security'), cssClass:'pi pi-shield', 'command': 'onOpenSecurity__Click' }] : []),   // Odoo 350042: passkey, приложение-аутентификатор, коды восстановления (только core / новая инфра)
                { 'title': this.$appState.darkTheme ? t('Sun theme') : t('Dark theme'), cssClass: this.$appState.darkTheme ? 'pi pi-sun' : 'pi pi-moon', 'command': 'toggleDarkMode' },
                // IE 2026 10 06 / ODOO-341407 (заказ Игоря п.3.2): в панели пользователя гамма, иконки и язык — одна строка с выпадающим списком (param, utils/menuParams.js):
                // выбор применяется сразу той же командой (menuPanelPick → executeStoreMethod), панель остаётся открытой. Радио-дети attrs остаются: их рисуют wj-menu,
                // мобильный флаттен, рейл «⋮» и панель при выключенном fe.ux.menuPanelParams
                { 'title': t('Color scheme'), _key: 'Color scheme', cssClass:'pi pi-palette',
                    param: { type: 'select', command: 'setColorScheme', field: 'colorScheme', value: () => this.store?.colorScheme, options: () => COLOR_SCHEMES.map(s => ({ id: s.id, title: t(s.title) })) },   // IE 2026 10 06 / ODOO-341407
                    attrs:
                    // пункты строим из единого источника COLOR_SCHEMES (порядок = порядок массива);
                    // галочка у активной гаммы, нейтральный кружок у остальных
                    COLOR_SCHEMES.map(s => ({
                        'title': t(s.title),   // IE 2026 09 23 / ODOO-341407: название схемы через словарь (Classic → Класична / Классическая, Style Nx → Стиль Nx)
                        cssClass: this.store?.colorScheme === s.id ? 'pi pi-check' : 'pi pi-circle',
                        'command': 'setColorScheme',
                        colorScheme: s.id,
                    })),
                },
                { 'title': t('Icon scheme'), _key: 'Icon scheme', cssClass:'pi pi-images',   // IE 2026 09 14 / ODOO-… (заказ Игоря: схемы иконок): подменю схем иконок — независимо от гаммы
                    param: { type: 'select', command: 'setIconScheme', field: 'iconScheme', value: () => this.store?.iconScheme, options: () => ICON_SCHEMES.map(s => ({ id: s.id, title: t(s.title) })) },   // IE 2026 10 06 / ODOO-341407 (заказ Игоря п.3.2): строка с выпадающим списком, как у гаммы
                    attrs:
                    ICON_SCHEMES.map(s => ({
                        'title': t(s.title),   // IE 2026 09 23 / ODOO-341407: название схемы через словарь (Classic → Класична / Классическая, Style Nx → Стиль Nx)
                        cssClass: this.store?.iconScheme === s.id ? 'pi pi-check' : 'pi pi-circle',
                        'command': 'setIconScheme',
                        iconScheme: s.id,
                    })),
                },
                { 'title': '-' },
                // IE 2026 09 07 / ODOO-337259 (заказ Игоря): подсказка хоткея — зажатый Alt показывает подсказки и без включения пункта
                { 'title': this.store?.showTooltip ? t('Hide tooltips') : t('Show tooltips'), hotkey: t('hold Alt'), 'command': 'showTooltip' },
                // IE 2026 10 25 / ODOO-345044 (заказ Игоря: меню по наведению — опцией, по умолчанию выкл): опция «Open menus on hover» — флажок в строке формы-меню (в wj-menu — пункт с галкой, клик переключает); нет при fe.ux.menuHoverOption = false
                ...(this.store?.menuHoverOption_flag?.() ? [{ 'title': t('Open menus on hover'), _key: 'Open menus on hover', cssClass: this.store?.menuHoverOpen ? 'pi pi-check' : 'pi pi-circle', 'command': 'menuHoverOpen',   // IE 2026 10 25 / ODOO-345044 (заказ Игоря: меню по наведению — опцией, по умолчанию выкл)
                    param: { type: 'check', command: 'menuHoverOpen', field: 'on', value: () => this.store?.menuHoverOpen === true } }] : []),   // IE 2026 10 25 / ODOO-345044 (заказ Игоря: меню по наведению — опцией, по умолчанию выкл)
                // demo-webscm 2026 11 02 / ODOO-350612 (заказ владельца: «опцию открывать навигатор при старте в настройках пользователя»): флажок — настройка USER (бэк user_settings_save, по умолчанию выкл)
                ...(navigator_on(this.store) ? [{ 'title': t('Open navigator at start'), _key: 'Open navigator at start', cssClass: this.store?.navigatorAtStart ? 'pi pi-check' : 'pi pi-circle', 'command': 'navigatorAtStart',
                    param: { type: 'check', command: 'navigatorAtStart', field: 'on', value: () => this.store?.navigatorAtStart === true } }] : []),
                // IE 2026 09 26 / ODOO-341407 (Igor 26.09): только языки, ВКЛЮЧЁННЫЕ в этой базе (сегмент I18N-LANGUAGES → fe.i18n.languages; без списка —
                // все); включён один язык — выбирать нечего, пункта нет. _settingsEpoch — меню перечитывает список после ответа бэка с настройками
                ...((void this.store?._settingsEpoch, i18n_enabledLanguages()).length > 1 ? [
                { 'title': t('Language'), _key: 'Language', cssClass:'pi pi-globe', _language: true,   // IE 2026 09 23 / ODOO-341407 (заказ Игоря): выбор языка интерфейса — English / Українська / Русский; IE 2026 10 06 / ODOO-341407: _key — ключ избранного строки-списка не зависит от языка
                    // IE 2026 10 06 / ODOO-341407 (заказ Игоря п.3.2): строка с выпадающим списком; подписи — самоназвания языков (не переводятся)
                    param: { type: 'select', command: 'setLanguage', field: 'language', value: () => getLanguage(), options: () => i18n_enabledLanguages().map(l => ({ id: l.id, title: l.title })) },
                    attrs:
                    i18n_enabledLanguages().map(l => ({
                        'title': l.title,
                        cssClass: getLanguage() === l.id ? 'pi pi-check' : 'pi pi-circle',
                        'command': 'setLanguage',
                        language: l.id,
                    })),
                }] : []),
                { 'title': this.store?.showSQL ? t('Hide SQL query texts') : t('Show SQL query texts'), 'command': 'showSQL' },
                { 'title': this.store?.profiling_params.use ? t('Stop profiling') : t('Start profiling'), 'command': 'profiling_params_use' },
                { 'title': '-' },
                { 'title': t('Restore closed widget'), hotkey: 'Alt Esc', cssClass:'pi pi-undo', 'command': 'restoreLastClosedWidget' },
				{ 'title': t('Paste widget (JSON)'), hotkey: 'Shift Alt V', cssClass:'pi pi-clipboard', 'command': 'copyPaste', method: 'pasteWidget' },
                { 'title': t('Import widget (JSON)'), cssClass:'pi pi-file-import', 'command': 'copyPaste', method: 'importWidget' },
                // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: импорт записей — меню и вставка): записи из буфера (Deep copy) → заполненная форма «Records Import»; буфер без записей — пустая форма с подсказкой (store.importRecords_fromClipboard)
                ...((void this.store?._settingsEpoch, importRecordsMenu_on((k, d) => this.store?.setting?.(k, d))) ? [
                { 'title': t('Todel: Import records'), cssClass:'pi ie-ico-records', 'command': 'copyPaste', method: 'importRecords' },   // IE 2026 11 02 / ODOO-349799 (todel-import-records): «Todel: » — пункт заменён сравнением и объединением конфигураций (источник Clipboard), по соглашению Todel: у старых обработок
                { 'title': t('Import records from file'), cssClass:'pi pi-file-import', 'command': 'copyPaste', method: 'importRecordsFile' }] : []),   // IE 2026 10 28 / ODOO-349799 (PR5): тот же импорт, текст — из файла
                { 'title': '-' },
                // IE 2026 08 28 / ODOO-5828 (заказ Игоря, уточнение дизайна): бывшее подменю Page —
                // три подменю Filters/Widgets/Page с полными названиями; краткие дубли Filters/Widgets
                // живут в табе Commands глобального меню чипсов
                { 'title': t('Filters'), _key: 'Filters', cssClass:'pi pi-filter', attrs: [   // IE 2026 09 23 / ODOO-341407: _key — языконезависимый ключ (menuFav_key шапки мобильного флаттена)
                    { 'title': t('Save as my defaults'), cssClass:'pi pi-save', 'command': 'defaults_save', backend_command: 'user_defaults_save', withWhere: true },
                    ...(this.isAdmin ? [
                        { 'title': t('Save as defaults for all'), cssClass:'pi pi-users', 'command': 'defaults_save', backend_command: 'workspace_defaults_save', withWhere: true },
                    ] : []),
                    { 'title': t('Use workspace defaults'), cssClass:'pi pi-filter-slash', 'command': 'defaults_save', backend_command: 'user_defaults_save', reset_where: true },
                ]},
                { 'title': t('Widgets'), _key: 'Widgets', cssClass:'pi pi-clone', attrs: [
                    { 'title': t('Save as my defaults'), cssClass:'pi pi-save', 'command': 'defaults_save', backend_command: 'user_defaults_save', withPage: true, withWidgets: true },
                    ...(this.isAdmin ? [
                        { 'title': t('Save as defaults for all'), cssClass:'pi pi-users', 'command': 'defaults_save', backend_command: 'page_defaults_save', withPage: true, withWidgets: true },
                    ] : []),
                    { 'title': t('Use page defaults'), cssClass:'pi pi-replay', 'command': 'defaults_save', backend_command: 'user_defaults_save', withPage: true, reset_widgets: true },
                    { 'title': '-' },
                    { 'title': t('Copy as JSON'), cssClass:'pi pi-copy', 'command': 'copyWidgets' },
                    { 'title': t('Copy as link'), cssClass:'pi pi-link', 'command': 'copyWidgets', asLink: true },
                    { 'title': '-' },
                    // IE 2026 09 08 / ODOO-… (заказ Игоря): режимы поведения свободных виджетов, когда активен докированный
                    // (галочка у текущего; зависимость от _settingsEpoch — меню перечитывает выбор после feSettings.set).
                    // На таче вложенное подменю не раскрывается — пункты кладём в Widgets плоско
                    ...(this.store?.mobileUi?.on
                        ? [{ 'title': t('Behavior'), _key: 'Behavior', cssClass: 'pi pi-sliders-h' }, ...(void this.store?._settingsEpoch, freeWidgets.menuItems())]
                        : [{ 'title': t('Behavior'), _key: 'Behavior', cssClass: 'pi pi-sliders-h', attrs: (void this.store?._settingsEpoch, freeWidgets.menuItems()) }]),
                ]},
                { 'title': t('Page'), _key: 'Page', cssClass:'pi pi-bookmark', attrs: [   // IE 2026 09 23 / ODOO-341407: _key — языконезависимый ключ
                    { 'title': t('Save as my default'), cssClass:'pi pi-save', 'command': 'defaults_save', backend_command: 'user_defaults_save', withPage: true, default_page: true },
                    ...(this.isAdmin ? [
                        { 'title': t('Save as default for all'), cssClass:'pi pi-users', 'command': 'defaults_save', backend_command: 'workspace_defaults_save', withPage: true },
                    ] : []),
                    { 'title': t('Make this my start workspace'), cssClass:'pi pi-bookmark-fill', 'command': 'defaults_save', backend_command: 'user_defaults_save', default_workspace: true },
                ]},
                { 'title': '-' },
                { 'title': this.store?.testRecording?.active ? t('Test recording') + ' ●' : t('Test recording'), _key: 'Test recording', cssClass:'pi pi-video', attrs: [   // IE 2026 09 23 / ODOO-341407: _key — языконезависимый ключ
                    { 'title': t('Start recording'), cssClass:'pi pi-circle-fill', 'command': 'test_record_start' },
                    { 'title': t('Stop recording'), cssClass:'pi pi-stop-circle', 'command': 'test_record_stop' },
                    { 'title': '-' },
                    { 'title': t('Test list'), cssClass:'pi pi-list', 'command': 'test_open_list' },
                ]},
                ...(this.isDeveloper ? [
                    { 'title': '-' },
                    /* pi-bug нет в этой версии PrimeIcons — рендерилась «рисочка» */
                    // IE 2026 09 11 / ODOO-335246 (Igor): подменю Debug — прежняя команда (сессия отладки бэкенда: контейнер,
                    // VS Code) под понятным именем + пошаговая отладка каскада (кнопка «Run debug iteration» внизу слева, App.vue)
                    { 'title': (this.store?.cascadeDebug?.on && this.isAdmin) ? t('Debug') + ' ●' : t('Debug'), _key: 'Debug', cssClass:'pi pi-code', attrs: [   // IE 2026 09 23 / ODOO-341407: _key — языконезависимый ключ
                        { 'title': t('Backend debug session'), cssClass:'pi pi-server', 'command': 'onOpenDebug__Click' },
                        // IE 2026 09 11 (Igor): пункт назван по действию (Start / Stop), а не по состоянию
                        // IE 2026 09 12 / ODOO-335246 (Igor): отладка каскада — только администраторам базы (access-admin); режим — в settings базы
                        ...(this.isAdmin ? (this.store?.cascadeDebug?.on
                            ? [{ 'title': t('Stop cascade debug'), cssClass:'pi pi-stop-circle', 'command': 'cascade_debug_toggle' }]
                            : [{ 'title': t('Start cascade debug'), cssClass:'pi pi-play', 'command': 'cascade_debug_toggle' }]) : []),
                    ]},
                ] : []),
                { 'title': '-' },
                { 'title': t('Log out'), cssClass:'pi pi-eject', 'command': 'onLogOut__Click' },
            ]
            // IE 2026 09 29 / ODOO-342781: роль «только чтение» — без пунктов записи (Save as … / Use … defaults, вставка и импорт виджета, запись тестов, отладка): их прячет store.readonly_menu
            // (те же правила, что checkAccess); подменю Test recording — инструмент разработчика — уходит целиком. Без роли — тот же массив, как было
            const items0 = this.store?.readonly_on?.() ? this.store.readonly_menu(items0_all.filter(it => it._key !== 'Test recording')) : items0_all   // Test recording — до фильтра: разделители вокруг него чистит сам фильтр
            // IE 2026 08 20 / ODOO-336291 (mobile UX): на таче подменю wijmo не раскрывается —
            // пункты с attrs разворачиваем плоско (шапка-разделитель + дети).
            // IE 2026 08 21 (замечание Игоря 19:44): rail-меню «⋮» (mmTap) флаттен
            // НЕ нужен — оно ходит вглубь стеком; сырой список отдаёт user_menu_raw
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties -- кэш сырого списка для user_menu_raw
            this._user_menu_raw = items0
            if (this.store?.mobileUi?.on) {
                return items0.flatMap(it => it.attrs?.length
                    ? [{ 'title': '-' }, { 'title': it.title, _key: it._key, cssClass: it.cssClass }, ...it.attrs, { 'title': '-' }]   // IE 2026 09 23 / ODOO-341407: _key — ключ избранного шапки не зависит от языка
                    : [it])
            }
            return items0
        },
        // IE 2026 09 22 / ODOO-… (предложение Игоря, шаг 2), уточнение Игоря по скрину: панель функций пользователя — двухуровневая группировка по назначению
        // (секции Account / Appearance / Defaults / Widgets / Tools, внутри — прежние папки Color scheme / Icon scheme / Filters / Widgets / Page /
        // Behavior / Test recording / Debug подзаголовками); пункты — те же объекты, что в user_menu (команды и состояния одни), список user_menu
        // для wj-menu и мобильного профиля не меняется
        user_menu_panel() {
            void this.user_menu
            const items = this._user_menu_raw || []
            const by = (pred) => items.find(pred)
            const byCmd = (c) => by(i => i.command === c)
            const byTitle = (ttl) => by(i => i._key === ttl || i.title === ttl)   // IE 2026 09 23 / ODOO-341407: i18n — title переведён, поиск по английскому ключу _key
            const widgets = byTitle('Widgets')
            const wAttrs = (widgets && widgets.attrs) || []
            const sec = (title, attrs) => ({ title, attrs: attrs.filter(Boolean) })
            return [
                // первый блок — команды правой части шапки (те же действия, что у её иконок: runRightAction)
                sec(t('Commands'), this.rightActions.map(a => ({ title: a.label, cssClass: a.icon, hotkey: a.hotkey || '', command: 'rightAction', _rightAction: a }))),
                sec(t('Account'), [byCmd('onOpenMyProfile__Click'), byCmd('onOpenSecurity__Click'), byCmd('onLogOut__Click')]),   // Odoo 350042: + Sign-in security
                // IE 2026 10 25 / ODOO-345044 (заказ Игоря: меню по наведению — опцией, по умолчанию выкл): «Open menus on hover» — сразу под Show tooltips
                sec(t('Appearance'), [byCmd('toggleDarkMode'), byCmd('showTooltip'), byCmd('menuHoverOpen'), byCmd('navigatorAtStart'), by(i => i._language), byTitle('Color scheme'), byTitle('Icon scheme')]),   // IE 2026 09 23 / ODOO-341407 (Igor: «перемести выбор языка вверх»): язык — сразу под Show tooltips, перед гаммой
                // секция Defaults (Filters / Widgets / Page) снята по скрину Игоря — умолчания живут в панели Commands глобальных чипсов
                sec(t('Widgets'), [byCmd('restoreLastClosedWidget'), by(i => i.method === 'pasteWidget'), by(i => i.method === 'importWidget'), by(i => i.method === 'importRecords'), by(i => i.method === 'importRecordsFile'),   // IE 2026 10 28 / ODOO-349799   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: импорт записей — меню и вставка)
                    ...wAttrs.filter(i => i.command === 'copyWidgets'), wAttrs.find(i => (i._key === 'Behavior' || i.title === 'Behavior') && i.attrs)]),
                sec(t('Tools'), [byCmd('showSQL'), byCmd('profiling_params_use'), by(i => i.attrs && i.attrs.some(a => a.command === 'test_record_start')),
                    by(i => i.attrs && i.attrs.some(a => a.command === 'onOpenDebug__Click'))]),
            ].filter(s => s.attrs.length)
        },
        user_menu_raw() {
            // IE 2026 08 21: тот же список БЕЗ мобильного флаттена — для rail-стека
            // «⋮» (user_menu кладёт сырой items0 в _user_menu_raw до флаттена)
            void this.user_menu
            return this._user_menu_raw || []
        },
        // правые иконки шапки — единый список для кнопок и меню «⋮»
        rightActions() {   // IE 2026 09 23 / ODOO-341407: i18n
            return [
                // IE 2026 09 22 / ODOO-… (предложение Игоря, шаг 2), по скрину: hotkey — в блок Commands панели пользователя; bar: false — команда только в панели, в шапке её иконки нет
                // IE 2026 11 03 / ODOO-350881 (инвентаризация помощи, этап 1): «?» страницы и её рабочей области — только при флаге fe.ux.helpCard (выключен — списка иконок не меняет)
                { icon: 'pi pi-question-circle', label: t('About this page'), tooltip: t('Help: what this page and its workspace are for'), show: helpCard_on(this.store) && !!this.store.activeWORKSPACE?.activePAGE, action: 'helpCardPage' },
                { icon: 'pi pi-compass', label: t('Navigator'), tooltip: t('Interface navigator (Alt N)'), hotkey: 'Alt N', show: this.showExtraView && navigator_on(this.store), action: 'navigatorToggle' },   // demo-webscm 2026 11 02 / ODOO-350612: правый док навигатора интерфейса
                { icon: 'pi pi-comments', label: t('Chats'), tooltip: t('Open chats (Alt K)'), hotkey: 'Alt K', show: this.showExtraView, action: 'globalChats' },
                { icon: 'globalSearch pi pi-search', label: t('Search'), tooltip: t('Search (F3)'), hotkey: 'F3', show: this.showExtraView, action: 'globalSearch' },
                { icon: 'globalHistory pi pi-hourglass', label: t('Recent activities'), tooltip: t('Recent activities'), show: true, action: 'globalHistory', bar: false },
                { icon: 'globalLog pi ie-ico-logs', label: t('Log'),   // IE 2026 09 13 / ODOO-… (иконки)
                 tooltip: t('Log'), show: this.showExtraView, action: 'globalLog', bar: false },
                { icon: 'pi pi-arrow-up-right-and-arrow-down-left-from-center', label: t('Full screen'), tooltip: t('Full screen'), show: true, action: 'onFullscreen__Click', bar: false },   // Игорь 22.09: из шапки убрать
            ].filter(a => a.show)
        },
        // IE 2026 08 20 / ODOO-336291 (mobile UX) (замечание Игоря): у процессной модели может не быть
        // title (запись ещё не загружена / не выбрана) — без фолбэка пункт подменю рисуется пустым
        pmMenuHeader() {
            // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): название на языке интерфейса (title_<L>), как в меню; выключатель fe.ux.pmArchiveSubmenu = false — title бэка как есть
            void this.store._settingsEpoch
            const rec = this.store.process_model_record
            if (this.store.setting('fe.ux.pmArchiveSubmenu', true) !== false) return pmMenu_recTitle(rec, getLanguage()) || t('Process model')
            return this.store.process_model_record?.title || t('Process model')   // IE 2026 09 23 / ODOO-341407: i18n
        },
        // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): значок модели в шапке — у архива свой (pi-history, как в меню), у прочих pi-sitemap; выключатель fe.ux.pmArchiveSubmenu = false — всегда pi-sitemap
        pmIcon() {
            void this.store._settingsEpoch
            if (this.store.setting('fe.ux.pmArchiveSubmenu', true) === false) return 'pi-sitemap'
            return pmMenu_recIcon(this.store.process_model_record)
        },
        // IE 2026 10 26 / ODOO-pending (заказ Игоря 26.10: меню процессной модели — форма меню с группировкой): кнопка модели — форма меню (components/PmMenuPanel.vue);
        // выключатель fe.ux.pmMenuForm (по умолчанию вкл.; false, мобильный профиль или без панелей-меню fe.ux.menuPanel — прежний wj-menu)
        // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): прежний список модели (wj-menu, телефон) — архивы родителя одним подменю «Archive (N)», свежие сверху (utils/pmMenuGroups.pmMenu_foldArchivesFlat);
        // выключатель fe.ux.pmArchiveSubmenu = false — список бэка как есть
        pmMenuFlat() {
            void this.store._settingsEpoch; void getLanguage()
            const menu = this.store.readonly_menu(this.store.process_model_menu, 'model')   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): открыт архив — без пунктов записи (Apply / Discard / Run auto-recalc …); 'model' — область модели (ревью #110599)
            if (this.store.setting('fe.ux.pmArchiveSubmenu', true) === false) return menu
            return pmMenu_foldArchivesFlat(menu, { t })
        },
        pmMenuFormOn() { void this.store._settingsEpoch; return this.store.menuPanel_on('') && this.store.setting('fe.ux.pmMenuForm', true) !== false },
        pmBtnClass() {
            const nc = !!(this.store.process_model_current && this.store.process_model_current !== this.store.process_model_record?.id)
            return ['p-link', 'pm-menu-btn', 'process-model-title', { 'no-current-process_model': nc }]
        },
        // IE 2026 09 22 / ODOO-… (предложение Игоря, шаг 2), по скрину: иконки шапки — без команд bar: false (Recent activities, Log живут в блоке Commands панели пользователя);
        // без панели (мобильный профиль, выключатель) иконки на месте, как раньше
        rightBarActions() {
            const panel = this.store.menuPanel_on('User')
            return this.rightActions.filter(a => !panel || a.bar !== false)
        },
        rightOverflowActions() {
            const list = this.rightBarActions
            return this.rightHidden > 0 ? list.slice(list.length - this.rightHidden) : []
        },
		// IE 2026 10 08 / ODOO-5800 (скрины Игоря: «Igor» / база / меню страницы в «⋮» открывали не те формы, что кнопки широкой шапки): строки «⋮» —
		// одна таблица видов (utils/topbarOverflow.js): тот же компонент, что у кнопки широкой шапки. Выключатель fe.ux.topbarOverflowSameMenus (false — прежние wj-menu)
		overflowSame() { void this.store._settingsEpoch; return topbarOverflowSame_on(this.store) },
		overflowRows() {
			return topbarOverflowRows({
				same: this.overflowSame, hideLeft2: this.hideLeft2, hideRight2: this.hideRight2,
				pageMenuPanel: this.pageMenuPanelOn, pageOnTitle: this.wsMenuOnTitle, pagesIcon: this.pageMenuPanelOn && !this.pagesOnTitle && !this.pagesOnRailToggle,
				tasksIcon: this.tasksPanelOn && !this.tasksOnTitle && !this.wsMenuOnTitle, userPanel: this.store.menuPanel_on('User'),
				hasDb: !!(this.store.user.database && 'title' in this.store.user.database),
			})
		},
		overflowLeftRows() { return this.overflowRows.filter(r => r.side === 'left') },
		overflowRightRows() { return this.overflowRows.filter(r => r.side === 'right') },
		// свойства и обработчики панелей шапки — одна таблица для широкой шапки и строки «⋮» (btnClass и слоты задаёт место)
		pageMenuBind() {
			return {
				openDelay: this.menuHoverMs, hover: this.menuHoverMs > 0, items: this.menuTree, icon: 'pi ie-ico-menu-panel', caret: false, title: t('Page menu'), subtitle: this.menuSub_page,
				search: true, searchPlaceholder: t('Search widgets…'), favKey: 'page',
				tooltip: t('Page menu: widgets, calculations and other commands of this page (hover or click)'),
				favOf: this.pageMenuFavOf, epoch: this.store._favEpoch, favTitle: t('Favourite'),
				openOf: this.pageMenuOpenOf, openCustom: this.pageMenuOpenCustom(), openTitle: t('Opens when the page opens (click to change; the set becomes personal)'),
				help: 'page', onPick: this.menuPanelPick, onFav: this.pageMenuFav, onOpenMark: this.pageMenuOpen, onOpenReset: this.pageMenuOpenReset,
				views: this.pageMenuViews, activeView: this.pageMenuViewCur, cards: this.pageMenuViewCur === 'previews', cardRatio: 1.8, tipPreview: this.pageMenuTipPreview, tools: this.pageMenuTools,
				onView: this.pageMenuViewSet, onTool: this.pageMenuTool, onOpen: this.pageMenuOpened,
			}
		},
		tasksMenuBind() {
			return {
				openDelay: this.menuHoverMs, hover: this.tasksMenuHover, items: this.tasksPanelItems,   // IE 2026 10 13 / ODOO-345044 (заказ Игоря 13.10): панель задач — только кликом icon: 'pi ie-ico-tasks-panel', caret: false, title: t('Tasks'), subtitle: this.menuSub_workspace,
				btnBadge: this.tasksErrBadge, search: true, searchPlaceholder: t('Search tasks…'), runsTitle: t('Tasks'),
				tooltip: this.tasksPanelTooltip, favKey: this.tasksFavKey, favOf: this.tasksFavOf, epoch: this.store._favEpoch, favTitle: t('Favourite task (for this workspace)'),
				refresh: true, refreshBusy: this.tasksPanelBusy, refreshTitle: this.tasksRefreshTitle, help: 'tasks', helpVars: this.tasksHelpVars,
				onOpen: this.tasksPanelOpened, onPick: this.tasksPanelPick, onFav: this.tasksPanelFav, onRefresh: this.tasksPanelRefresh,
			}
		},
		userMenuBind() {
			return {
				openDelay: this.menuHoverMs, hover: this.menuHoverMs > 0, items: this.user_menu_panel, align: 'right', caret: false, title: t('User menu'), titleIcon: 'pi pi-user', subtitle: String(this.store.user.title || ''),
				search: true, searchPlaceholder: t('Search commands…'), favKey: 'user', favOf: this.userMenuFavOf, epoch: this.store._favEpoch, favTitle: t('Favourite command'),
				help: 'user', onPick: this.menuPanelPick, onFav: this.userMenuFav,
			}
		},
        mmItems() {
            return this.mobileMenu?.stack[this.mobileMenu.stack.length - 1]?.items || []
        },
        // IE 2026 08 22: плоский обход с inline-раскрытием (_open) и глубиной
        mmFlat() {
            const out = []
            const walk = (list, depth) => {
                for (const raw of (list || [])) {
                    const title = raw.title || raw.node?.valueStr || raw.valueStr || ''
                    if (title === '-' || title === '') continue
                    const folder = !!(raw.attrs && raw.attrs.length)
                    out.push({ it: raw, title,
                        pi: raw.pi || raw.cssClass || raw.node?.pi || '', folder, depth })
                    if (folder && raw._open) walk(raw.attrs, depth + 1)
                }
            }
            walk(this.mobileMenu?.stack?.[0]?.items, 0)
            return out
        },
	},
    setup() {
        const store = useMainStore();
		const showMenuToggle = true
		const showExtraView = store.checkAccess({ 'command': 'onMenuToggle', 'viewAccess':'access-extraView' });
        return {
			// workspace,
            store,
			showMenuToggle,
			showExtraView,
        }
    },
    created() {
        this.store.AppTopbar = this
    },
	mounted() {
		const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');
		// системную настройку берём только когда пользователь сам ничего не выбирал,
		// иначе она затирала бы сохранённую тему при каждом входе
		if (this.store?.darkThemePref !== null && this.store?.darkThemePref !== undefined) {
			this.$appState.darkTheme = this.store.darkThemePref;
		} else if (localStorage.getItem('webscm_darkTheme') !== null) {
			this.$appState.darkTheme = localStorage.getItem('webscm_darkTheme') === 'true';
		} else {
			// IE 2026 09 05 / ODOO-336330: тема по умолчанию — настройка базы fe.appearance.darkThemeDefault
			// ('dark' | 'light'; пусто/'system' = системная prefers-color-scheme)
			const _dt = this.store?.setting?.('fe.appearance.darkThemeDefault', '')
			this.$appState.darkTheme = _dt === 'dark' ? true : _dt === 'light' ? false : prefersDark.matches;
		}

		prefersDark.addEventListener('change', this.updateSystemTheme);

		this._chipsObserver = new ResizeObserver(this._updateChipsMultiRow);
		this.$nextTick(this._setupChipsObserver);

		// адаптивность правых иконок: наблюдаем шапку и блок чипсов (ширина чипсов
		// меняется при любом перераспределении места) + первый замер
		this._rightRO = new ResizeObserver(() => {
			if (this._rightRaf) cancelAnimationFrame(this._rightRaf);
			this._rightRaf = requestAnimationFrame(() => { this._rightRaf = null; this._measureRightIcons(); });
		});
		this._rightRO.observe(this.$el);
		this.$nextTick(() => {
			if (this.$refs.topbarChips) this._rightRO.observe(this.$refs.topbarChips.$el || this.$refs.topbarChips);
			this._measureRightIcons();
		});
		document.addEventListener('click', this._closeRightMenu, true);
		window._mobTopbarSync?.() // IE 2026 09 04 / ODOO-336291 (mobile UX): P-22 — шапка смонтирована: замер --mob-topbar-h без постоянного опроса
	},
	beforeUnmount() {
		this._chipsObserver?.disconnect();
		cancelAnimationFrame(this._chipsRaf);
this._rightRO?.disconnect();
		if (this._rightRaf) cancelAnimationFrame(this._rightRaf);
		document.removeEventListener('click', this._closeRightMenu, true);
		this.closeDbPicker();
	},
	// beforeDestroy() {
	// 	const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');
	// 	prefersDark.removeEventListener('change', this.updateSystemTheme);
	// },
    methods: {
		// IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка на остальных элементах — рейл / чипс / стол): правая кнопка по пустому месту стола (Page.vue) — та же панель ≡
		// «Page menu», что открывает кнопка шапки, у точки клика (MenuPanel.show({ at })); панели нет (мобильный профиль, fe.ux.menuPanelPage = false) — false, меню браузера
		// IE 2026 11 02 / ODOO-350449 (заказ Игоря: p214 єдине меню робочої області — вкладки Меню / Сторінки / Завдання): открыть форму меню рабочей области на вкладке (store.workspaceMenu_open — пункт «All pages…» рейла); формы нет (выключатель, мобильный профиль) — false
		workspaceMenu_show(tab, at) {
			const f = this.$refs.pageMenuPanel
			if (!this.wsMenuTabsOn || !f || typeof f.show !== 'function') return false
			return f.show({ by: 'click', tab, at }) !== false
		},
		ctxMenu_pageMenu(at) {
			const mp = this.$refs.pageMenuPanel
			if (!mp || typeof mp.show !== 'function') return false
			if (!mp.open) mp.show({ by: 'click', at })
			return true
		},
		ackAlarm() {
			const ws = this.store.activeWORKSPACE?.workspace
			if (ws) this.alarmAckByWs = { ...this.alarmAckByWs, [ws]: true }
		},
		reopenAlarm() {
			const ws = this.store.activeWORKSPACE?.workspace
			if (ws) this.alarmAckByWs = { ...this.alarmAckByWs, [ws]: false }
		},
		_setupChipsObserver() {
			this._chipsObserver.disconnect();
			if (this.$refs.topbarChips) {
				this._chipsObserver.observe(this.$refs.topbarChips);
				this._updateChipsMultiRow();
			} else {
				this.chipsMultiRow = false;
			}
		},
		// IE 2026 08 20 / ODOO-336291 (mobile UX), 21.08: тап по строке (иконке/подписи) = тап по самому меню
		ovmRowTap(e) {
			if (e.target.closest('.wj-menu')) return
			const host = e.currentTarget.querySelector('.wj-menu')
			const ctrl = host && window.wijmo?.Control?.getControl(host)
			if (ctrl) ctrl.isDroppedDown = !ctrl.isDroppedDown
		},
		runRightAction(a) {
			this[a.action]?.()
		},
		// узкая шапка: прячем в «⋮» поэтапно — правые иконки, затем базу/модель/
		// пользователя, затем меню Widgets/Calc/More (аналог overflow панели грида)
		_measureRightIcons() {
			const bar = this.$el
			const wrap = this.$refs.rightIcons
			const more = this.$refs.rightMore
			if (!bar || !wrap || !more) return
			const btns = [...wrap.querySelectorAll('.tb-right-icon')]
			const left2 = this.$refs.left2
			const right2 = this.$refs.right2
			// IE 2026 09 04 / ODOO-336291 (mobile UX): B-10 — на телефоне мини-меню Widgets/Calc/More (25 px, 12 px текст, wijmo-дропдаун шире экрана)
			// всегда свёрнуты в «⋮» (там они уже папками); раньше зависело от тайминга замера ширины
			const mob = !!this.store.mobileUi?.on
			btns.forEach(b => { b.style.display = '' })
			if (left2) left2.style.display = mob ? 'none' : ''
			if (right2) right2.style.display = ''
			more.style.display = 'none'
			const fits = () => bar.scrollWidth <= bar.clientWidth + 1
			let hidden = 0, hLeft2 = mob, hRight2 = false
			if (!fits()) {
				more.style.display = ''
				while (hidden < btns.length && !fits()) {
					btns[btns.length - 1 - hidden].style.display = 'none'
					hidden++
				}
				if (!fits() && right2) { right2.style.display = 'none'; hRight2 = true }
				if (!fits() && left2 && !mob) { left2.style.display = 'none'; hLeft2 = true }
			}
			const any = hidden > 0 || hLeft2 || hRight2
			more.style.display = any ? '' : 'none'
			this.rightHidden = hidden
			this.hideLeft2 = hLeft2
			this.hideRight2 = hRight2
			if (!any) this.rightMenuOpen = false
		},
		_closeRightMenu(e) {
			// IE 2026 08 20 / ODOO-336291 (mobile UX): выпадашки wj-menu живут в body (вне rightIcons) —
			// capture-клик по их пункту закрывал «⋮», wj-menu размонтировался и пункт НЕ срабатывал
			// (на телефоне: Color scheme/Full screen «без реакции»)
			if (e.target.closest?.('.wj-dropdown-panel')) return
			// IE 2026 10 08 / ODOO-5800: панели MenuPanel / PagesPanel живут в body (teleport), DatabasePicker — admin-диалог PrimeVue тоже; клик внутри них «⋮» не закрывает
			if (e.target.closest?.('.menu-panel, .db-picker-popup, .p-dialog, .p-dialog-mask')) return
			if (this.rightMenuOpen && !this.$refs.rightIcons?.contains(e.target)) {
				this.rightMenuOpen = false
			}
		},
		_updateChipsMultiRow() {
			cancelAnimationFrame(this._chipsRaf);
			this._chipsRaf = requestAnimationFrame(() => {
				if (Date.now() - (this._chipsLastChange ?? 0) < 1000) {
					// console.log(`Skipping chips multi-row check to prevent loop ${this._chipsLastChange}`);
					return;
				} 

				const el = this.$refs.topbarChips;
				const height = el?.$el?.offsetHeight ?? el?.offsetHeight ?? 0;
				const multiRow = height > 42;

				if (this.chipsMultiRow !== multiRow) {
					console.log('Chips multi-row changed:', multiRow);
					this.chipsMultiRow = multiRow;
					this._chipsLastChange = Date.now();
					// Set paused synchronously so the activeChipsCount watcher
					// sees it even if it fires before the nextTick below runs.
					this._chipsObserverPaused = true;
					const token = ++this._disconnectToken;
					this.$nextTick(() => {
						// Only disconnect if the watcher hasn't already cancelled
						// this pending disconnect by incrementing _disconnectToken.
						if (this._disconnectToken === token) {
							this._chipsObserver.disconnect();
						}
					});
				}
			});
		},
        handleMouseEnter(event) {
			// IE 2026 09 04 / ODOO-336291 (mobile UX): B-26 / P-19 hamburgerTap — на таче совместимый mouseenter открывал сайдбар раньше click
			// (тот уходил в появившуюся маску); открытие — только по click. Выкл: window.mobileUi.set('hamburgerTap', false)
			if (this.store.mobileUi?.on && this.store.mobileUi.hamburgerTap !== false) return
			if (this.hoverLock) return   // IE 2026 10 29 / ODOO-5800 (заказ Игоря 29.10: кнопка «закрыть список столов» на месте кнопки шапки — без повторного открытия наведением)
			if (!this.store.menuHoverOpen_on()) return   // IE 2026 10 25 / ODOO-345044 (заказ Игоря: меню по наведению — опцией, по умолчанию выкл): опция «Open menus on hover» выкл — список столов открывает только клик (onMenuToggle)
			if (this.showMenuToggle) {
	            // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U2 (дефект defects-found.md/topbar-nav, findings[0]: и mouseenter, и click шлют один и тот же
	            // переключатель menu-toggle — клик сразу после наведения закрывал список, который только что открыло наведение):
	            // метка момента, когда наведение переключило список
	            this._menuHoverToggleAt = Date.now()
	            this.$emit('menu-toggle', event);
			}
        },
        onMenuToggle(event) {
			if (this.showMenuToggle) {
				// IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U2: наведение только что само переключило список (handleMouseEnter, в течение ~400 мс) — клик той же
				// связки mouseenter+click не переключает его ещё раз; клик позже (пользователь решил закрыть отдельно) работает как раньше
				if (this._menuHoverToggleAt && Date.now() - this._menuHoverToggleAt < 400) return
				this.$emit('menu-toggle', event);
			}
        },
		onTopbarMenuToggle(event) {
            this.$emit('topbar-menu-toggle', event);
        },
		topbarImage() {
			return this.$appState.darkTheme ? 'images/logo-white.svg' : 'images/logo-dark.svg';
		},
		menuInitialized(menu){
			// this.menu = menu;
		},
		initMenu(menu) {
			this[menu.hostElement.id] = menu;
		},
		// menuCommand(param) {
			// 	let this_ = this
			// 	return {
				// 		executeStoreMethod: function(param){
					// 			let vueObj = this_.store.activeWIDGET.vueObj
					// 			vueObj.store.executeStoreMethod(vueObj, param)
					// 		},
		// 		canExecuteCommand: function(param){
			// 			return true;
			// 		}
			// 	}
		// },
		switchDatabase() {
			this.store.process_model_record = { id: '' }
			this.store.process_model_current = '' // ODOO-3749: current — атрибут базы
			this.store.recentWorkspaces = []
			this.store.menuTree = []
			this.store.WORKSPACES = {}
			this.store.database_attrs = []
			this.$router.push({ name: 'selectDatabase' })
		},
		// --- Database picker popup (ODOO-3483) ---
		toggleDbPicker() {
			if (this.dbPickerVisible) { this.closeDbPicker(); return }
			this.dbPickerVisible = true
			this._dbPickerClickOutside = (event) => {
				// admin-info Dialog is teleported to body — a click inside it is
				// NOT "outside" the picker (closing would unmount the dialog too)
				if (event.target.closest?.('.p-dialog, .p-dialog-mask')) return
				if (this._dbPickerRef('dbPicker')?.admin?.visible) return
				const box = this._dbPickerRef('dbPickerBox')
				if (box && !box.contains(event.target)) this.closeDbPicker()
			}
			this._dbPickerKeydown = (event) => {
				if (event.key !== 'Escape') return
				if (this._dbPickerRef('dbPicker')?.admin?.visible) return // Dialog handles its own Escape
				this.closeDbPicker()
			}
			setTimeout(() => {
				document.addEventListener('click', this._dbPickerClickOutside)
				document.addEventListener('keydown', this._dbPickerKeydown)
				this._dbPickerRef('dbPicker')?.focus?.()
			}, 100)
		},
		// IE 2026 10 08 / ODOO-5800: та же всплывашка базы в строке «⋮» лежит внутри v-for (overflowRightRows) — Vue 3 отдаёт такой ref массивом
		// (проба ботом: «this.$refs.dbPicker?.focus is not a function»); берём первый живой элемент в обоих местах
		_dbPickerRef(name) { const r = this.$refs[name]; return Array.isArray(r) ? r.find(Boolean) : r },
		closeDbPicker() {
			this.dbPickerVisible = false
			document.removeEventListener('click', this._dbPickerClickOutside)
			document.removeEventListener('keydown', this._dbPickerKeydown)
		},
		onDbPicked(db) {
			this.closeDbPicker()
			// Same contract as the old wj-menu items from get_database_menu:
			// set_database in mainStore (real re-init on switch — ODOO-3484).
			this.store.executeStoreMethod(this, { command: 'set_database', dbid: db.dbid, title: db.title || db.name, workspace_onOpening: db.workspace_onOpening })
		},
		// IE 2026 08 20 / ODOO-336291 (mobile UX), 21.08: «⋮» на телефоне открывает рейл-лист
		tbMoreTap() {
			if (this.store.mobileUi?.on) {
				if (this.mobileMenu) { this.mobileMenu = null; return }
				this.mobileMenuOpen()
				window.mobTapDone?.('more') // IE 2026 09 04 / ODOO-336291 (mobile UX): P-31
				return
			}
			this.rightMenuOpen = !this.rightMenuOpen
		},
		mobileMenuOpen() {
			const items = []
			for (const m of (this.menuTree || []))
				items.push({ title: m.node?.valueStr || m.title || '', pi: m.node?.pi || m.pi || 'pi pi-th-large', attrs: m.attrs, src: m })
			for (const a of this.rightActions) {
				// IE 2026 08 21 (замечание Игоря): Full screen на телефоне не нужен
				if (a.action === 'onFullscreen__Click') continue
				items.push({ title: a.label, pi: a.icon, action: a })
			}
			if (this.store.user.database && 'title' in this.store.user.database)
				items.push({ title: this.store.user.database.title, pi: 'pi pi-database', attrs: this.store.database_attrs, _db: true })
			items.push({ title: this.pmMenuHeader, pi: 'pi pi-sitemap', attrs: this.pmMenuFlat })   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ)
			items.push({ title: this.store.user.title, pi: 'pi pi-user', attrs: this.user_menu_raw })
			// IE 2026 08 21 (вопрос Игоря): standalone («На экран Домой») без адресной
			// строки — перезагрузить страницу нечем; штатный пункт меню
			items.push({ title: t('Reload page'), pi: 'pi pi-refresh', _reload: true })   // IE 2026 09 23 / ODOO-341407: i18n
			this.mobileMenu = { stack: [{ title: '', items }] }
			this.store.mobileMenus_closeOthers?.('more') // IE 2026 09 04 / ODOO-336291 (mobile UX): B-08 menuExclusive — рейл / список виджетов / гамбургер закрываются
		},
		// 21.08: id избранных («Мои») баз — как в DatabasePicker (list_user_databases)
		async mmLoadFavDbIds() {
			if (this._mmFavIds) return this._mmFavIds
			try {
				const r = await fetch(this.store.url_backend_login, {
					method: 'POST', credentials: 'include',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({ command: 'list_user_databases', user: {
						email: this.store.user?.doc?.email || this.store.user?.email || '',
						id: this.store.user?.id || '',
					} }),
				})
				const a = await r.json()
				this._mmFavIds = new Set((a.databases || []).filter(d => d.is_my)
					.map(d => d.database_id || d.dbid || d.id).filter(Boolean))
			} catch (e) { this._mmFavIds = new Set() }
			return this._mmFavIds
		},
		mmBack() {
			if (!this.mobileMenu) return
			this.mobileMenu.stack.pop()
			if (this.mobileMenu.stack.length === 0) this.mobileMenu = null
		},
		async mmTap(it) {
			if (it.attrs && it.attrs.length) {
				// IE 2026 08 22: inline — раскрыть/свернуть детей под пунктом
				if (it._db && !it._dbPrepared) {
					// база: по умолчанию избранные («Мои»), остальные за All databases
					const favIds = await this.mmLoadFavDbIds()
					const dbs = it.attrs.filter(a => a.dbid)
					const fav = dbs.filter(a => favIds.has(a.dbid))
					const rest = dbs.filter(a => !favIds.has(a.dbid))
					if (fav.length && rest.length) {
						const service = it.attrs.filter(a => !a.dbid)
						it.attrs = [...service, ...fav, { title: t('All databases'), pi: 'pi pi-list', attrs: rest }]   // IE 2026 09 23 / ODOO-341407: i18n
					}
					it._dbPrepared = true
				}
				it._open = !it._open
				// IE 2026 09 04 / ODOO-336291 (mobile UX): B-09 — папку к верху панели больше не прокручиваем: под пальцем оказывалась команда из детей
				// (повторный тап в аудите открыл диалог полного пересчёта). Заголовок остаётся на месте; scrollIntoView
				// nearest подвинет список только если сам заголовок частично срезан краем панели
				if (it._open) this.$nextTick(() => {
					const p = document.querySelector('.mobile-tabs-list.mobile-menu-right')
					const i = this.mmFlat.findIndex(n => n.it === it)
					const el = p?.querySelectorAll?.('.mm-row')?.[i]
					try { el?.scrollIntoView({ block: 'nearest' }) } catch (e) { /* старый WebKit без options */ }
					window.mobTapDone?.('moreFolder') // P-31
				})
				return
			}
			if (it._reload) { location.reload(); return }
			if (it.action) { this.runRightAction(it.action); this.mobileMenu = null; return }
			const action = { ...(it.src || it) } // IE 2026 08 22: inline-дети — сырые пункты без .src
			// как menuNodeClicked: пункт без command/widget/значения — не действие
			if (!action.command && !action.widget && !action.node?.value) return
			action.command = action.command || 'widget_open'
			if (action.command === 'onOpenDebug__Click') { this.openDebug(); this.mobileMenu = null; return }
			action.widget = action.widget || action.node?.value
			let vueObj = this
			if (this.store.activeWIDGET) vueObj = this.store.activeWIDGET.vueObj
			this.mobileMenu = null
			this.store.executeStoreMethod(vueObj, this.store.menuActionActiveDesk(action))   // IE 2026 10 16 / ODOO-345912
		},
		// IE 2026 09 22 / ODOO-… (предложение Игоря): пункт панели функций (меню страницы, меню пользователя) — то же действие, что у пункта wj-menu (menuNodeClicked)
		// IE 2026 09 22 / ODOO-… (заказ Игоря): пометки панелей — звезда виджета (избранный: открывать при открытии страницы), звезда страницы
		// (показывать в рейле), домик (страница по умолчанию); переход на страницу / виджет из панели страниц
		// IE 2026 09 22 (уточнение Игоря): звезда виджета — только избранное (отбор в панели); команды Calc / More — избранные команд меню (ключ 'page')
		pageMenuFavOf(raw) {
			const id = raw && (raw.widget || (raw.node?.relation_segment ? raw.node?.value : null))
			const WS = this.store.activeWORKSPACE
			if (!id) return (raw && !raw.attrs?.length) ? this.store.menuFav_has('page', raw) : null
			return !!WS && this.store.favorites_widgets(WS.workspace, WS.active_page).includes(String(id))
		},
		pageMenuFav(raw, on) {
			const id = raw && (raw.widget || (raw.node?.relation_segment ? raw.node?.value : null))
			const WS = this.store.activeWORKSPACE
			if (!id) { this.store.menuFav_toggle('page', raw, on); return }
			if (id && WS) this.store.favorites_toggleWidget(WS.workspace, WS.active_page, id, on)
		},
		// IE 2026 09 22 (уточнение Игоря): «открывается со страницей» — умолчания страницы (onOpening), первое изменение фиксирует личный набор целиком
		pageMenuOpenOf(raw) {
			const id = raw && (raw.widget || (raw.node?.relation_segment ? raw.node?.value : null))
			if (!id) return null
			const WS = this.store.activeWORKSPACE
			return !!WS && this.store.page_openSet(WS.workspace, WS.active_page).ids.includes(String(id))
		},
		pageMenuOpen(raw, on) {
			const id = raw && (raw.widget || (raw.node?.relation_segment ? raw.node?.value : null))
			const WS = this.store.activeWORKSPACE
			if (id && WS) this.store.favorites_toggleOpen(WS.workspace, WS.active_page, id, on)
		},
		pageMenuOpenCustom() { void this.store._favEpoch; const WS = this.store.activeWORKSPACE; return !!WS && this.store.page_openSet(WS.workspace, WS.active_page).custom },
		pageMenuOpenReset() { const WS = this.store.activeWORKSPACE; if (WS) this.store.favorites_resetOpens(WS.workspace, WS.active_page) },
		// IE 2026 09 27 / ODOO-… (заказ Игоря: картинки виджетов): вид меню страницы — память выбора (этот браузер, пользователь и база); в виде previews при открытии — картинки активной страницы (full)
		_pageMenuViewKey() { const s = this.store, u = s.user?.id || s.user?.email || 'user', db = s.user?.database?.dbid || ''; return `pageMenuView:${u}:${db}` },
		pageMenuViewLoad() { try { const v = localStorage.getItem(this._pageMenuViewKey()); this.pageMenuViewId = v === 'previews' ? 'previews' : 'list' } catch (e) { /* хранилище недоступно — выбор этого экземпляра */ } },
		pageMenuViewSet(id) {
			if (!['list', 'previews'].includes(id)) return
			this.pageMenuViewId = id
			try { localStorage.setItem(this._pageMenuViewKey(), id) } catch (e) { /* хранилище недоступно — выбор живёт до перезагрузки */ }
			if (id === 'previews') this.pageMenuPreviewsLoad()
		},
		pageMenuOpened() { this.pageMenuViewLoad(); if (this.pageMenuViewCur === 'previews') this.pageMenuPreviewsLoad() },
		pageMenuPreviewsLoad() { const WS = this.store.activeWORKSPACE; if (WS && WS.active_page) widgetPreviews_load(this.store, [WS.active_page], 'full') },
		pageMenuPicOf(raw) { void wpState.epoch; const WS = this.store.activeWORKSPACE; return (WS && raw && wpRowWidget(raw)) ? widgetPreviews_picOfRow(WS.active_page, raw, 'full') : null },
		pageMenuTipPreview(raw, g) { const WS = this.store.activeWORKSPACE; return WS ? menuTipPreview_widget(this.store, WS.active_page, raw, g && g.w, g && g.h) : '' },   // IE 2026 10 04 / ODOO-345046 (заказ Игоря: превью в Alt-подсказке пунктов меню): картинка виджета в Alt-подсказке пункта меню страницы
		pageMenuIconOf(raw) { try { return pageSchema_icon(raw) } catch (e) { return 'pi pi-window-maximize' } },
		pageMenuTitleOf(raw) { return String((raw && (raw.node?.valueStr || raw.title || raw.titleAction)) || '') },
		pageMenuLayOf(raw) { return (raw && wpRowWidget(raw)) ? wpLayOf(raw) : null },
		pageMenuTool(id) { if (id === 'previewsUpdate') widgetPreviews_updatePage(this.store) },
		// IE 2026 09 22 (заказ Игоря, п.2 и п.4): избранные команд панели пользователя (ключ 'user'); IE 2026 09 26 / ODOO-… (заказ Игоря: виды панели страниц): текущая страница панели страниц — PagesPanel.currentOf
		// IE 2026 10 06 / ODOO-341407 (заказ Игоря п.3.2): звезда и у строки-списка (папка с param рисуется пунктом); при выключенном fe.ux.menuPanelParams — снова папка, без звезды
		userMenuFavOf(raw) { return (raw && (!raw.attrs?.length || (menuParam_has(raw) && menuParams_on(this.store)))) ? this.store.menuFav_has('user', raw) : null },
		userMenuFav(raw, on) { this.store.menuFav_toggle('user', raw, on) },
		// IE 2026 09 23 / ODOO-… (заказ Игоря: панель задач в шапке): контекст общего модуля панели задач — словари стора, формат даты запуска, перевод,
		// запись стола для кнопки «вставить» подсказки пункта
		tasksCtx() {
			const store = this.store, rec = this.tasksRecord
			const dictRow = (segment, id) => { const IS = store.itemsSource?.[segment]; if (!IS || id == null || id === '') return null; return IS.ids?.[id] || (IS.data || []).find(x => x && String(x.id) === String(id)) || null }
			return {
				dictRow, t: (text, params) => t(text, params),
				listFolder: store.setting('fe.ux.treeListFolderOpen', true) !== false,   // IE 2026 10 24 / ODOO-348705 (заказ Игоря: иконка ссылки на список в дереве — как ярлык списка): ссылка на запись WIDGET-LIST — pi-folder-open (дефолт ВКЛ)
				formatDate: (s) => store.formatDateHTML(String(s), true),
				paste: rec?.id ? { record: String(rec.id), segment: String(rec.segment || '') } : null,
				// IE 2026 09 23 / ODOO-… (заказ Игоря: панель задач в шапке — названия): название узла-ссылки без названия (в снимке «только вид» valueStr = id) —
				// кэш стора (catalog_titles по снимку, tasksBar_resolveTitles), иначе словарь сегмента; нет — id (как раньше)
				titleFor: (id, seg) => store.tasksBar_title(this.tasksWs, id) || String((seg && dictRow(seg, id) || {}).title || ''),
			}
		},
		// словари для пунктов: статусы — целиком (их немного), сегменты — только у узлов без своей иконки; вместо виджета — заглушка (get_itemsSource ждёт vueObj.WIDGET)
		tasksDicts_request() {
			const store = this.store, stub = { WIDGET: { workspace: this.tasksWs, page: this.store.activeWORKSPACE?.active_page || '' }, attr: null }
			try { store.get_itemsSource(stub, {}, { attr_type: 'AttrLink', relation_segment: 'STATUS' }, { fetchMode: 'all' }) } catch (e) { /* без словаря — id статуса */ }
			const segs = tasksPanel_segments(this.tasksRows)
			if (segs.length) { try { store.get_itemsSource(stub, {}, { attr_type: 'AttrLink', relation_segment: 'SEGMENTS' }, { fetchMode: 'by_ids', ids: segs }) } catch (e) { /* значок по типу узла */ } }
		},
		// открытие / смена стола: словари и один запрос свежих статусов (fe.ux.tasksBarAutoFetch; снимок не старше fe.data.tasksBarStaleSec не перечитывается)
		tasksPanel_init() {
			if (!this.tasksPanelOn || !this.tasksWs) return
			this.tasksDicts_request()
			if (this.store.setting('fe.ux.tasksBarAutoFetch', true) !== false) this.store.tasksBar_refresh(this.tasksWs)
		},
		// открытие панели: снимок старше fe.data.tasksBarStaleSec (60 с) перечитывается; кнопка ↻ — всегда
		tasksPanelOpened() { this.tasksDicts_request(); if (this.store.setting('fe.ux.tasksBarAutoFetch', true) !== false) this.store.tasksBar_refresh(this.tasksWs) },
		tasksPanelRefresh() { this.store.tasksBar_refresh(this.tasksWs, { force: true }) },
		// клик по пункту-задаче — виджет записи задачи на ТЕКУЩЕЙ странице стола (widget_open без родителя-виджета: стол / страница — активные), с активацией
		tasksPanelPick(raw) {
			if (raw && raw._settingsPage) { this.store.settingsPage_open(this.tasksWs); return }   // IE 2026 10 28 / ODOO-5800 (заказ Игоря: страница настроек стола — из меню задач, не из списка страниц)
			const action = tasksPanel_openAction(raw?._open)
			if (!action) return
			try { this.store.executeStoreMethod(this, action) } catch (e) { console.warn('tasks panel: open record failed', e) }
		},
		// избранное — те же личные пометки, что у вкладки Tasks panel формы стола (ключ tasks:<id записи стола>)
		tasksFavOf(raw) { return raw?._open ? this.store.menuFav_list(this.tasksFavKey).includes(raw._open.id) : null },
		tasksPanelFav(raw, on) {
			const id = raw?._open?.id
			if (!id || !this.tasksRecord?.id) return
			const cur = this.store.menuFav_list(this.tasksFavKey).filter(x => x !== id)
			this.store.favorites_save({ fav_menu: { key: this.tasksFavKey, items: on ? [...cur, id] : cur } })
		},
		menuPanelPick(item) {
			if (item && item._rightAction) { this.runRightAction(item._rightAction); return }   // блок Commands панели пользователя
			if (item && typeof item._fn === 'function') { item._fn(); return }   // блок Commands панели страницы
			const action = { ...(item || {}) }
			if (!action.command && !action.widget && !action.node?.value) return
			action.command = action.command || 'widget_open'
			if (action.command === 'onOpenDebug__Click') { this.openDebug(); return }
			action.widget = action.widget || action.node?.value
			let vueObj = this
			if (this.store.activeWIDGET) vueObj = this.store.activeWIDGET.vueObj
			this.store.executeStoreMethod(vueObj, action)
		},
		menuNodeClicked(menu) {
			let action = null
			if (menu.selectedIndex==-1 && this.store.activeWORKSPACE.groupMenu) {
				action = this.menuTree[menu.hostElement.id.slice(-1)]
			} else {
				action = menu.itemsSource[menu.selectedIndex]
			}
			action = {...action}
			// IE 2026 08 20 / ODOO-336291 (mobile UX): шапка/родитель подменю без command —
			// не подставлять widget_open с пустым widget (мусорное действие на таче)
			if (!action.command && !action.widget && !action.node?.value) return
			action.command = action.command || 'widget_open'
			if (action.command === 'onOpenDebug__Click') { this.openDebug(); return }
			action.widget = action.widget || action.node?.value
			let vueObj = this
			if (this.store.activeWIDGET) {
				vueObj = this.store.activeWIDGET.vueObj 
			}
			this.rightMenuOpen = false // IE 2026 08 20 / ODOO-336291 (mobile UX): команда выбрана — «⋮» сложить
			this.store.executeStoreMethod(vueObj, this.store.menuActionActiveDesk(action))   // IE 2026 10 16 / ODOO-345912
		},
		onShowSettings__Click(event) {
			let vueObj = this
			if (this.store.activeWIDGET) {
				vueObj = this.store.activeWIDGET.vueObj 
			}
			this.store.executeStoreMethod(vueObj, {command: "onShowSettings__Click"})
		},
		onClick: function(action) {
			let vueObj = this
			if (this.store.activeWIDGET) {
				vueObj = this.store.activeWIDGET.vueObj 
			}
			vueObj.store.executeStoreMethod(vueObj, action)
		},
		initWidget: function(popup){
			this[popup.hostElement.id] = popup;
		},
		onSubmit: function(popup){
			alert(t('WIDGET submitted'));   // IE 2026 09 23 / ODOO-341407: i18n
			popup.hide();
		},
		navigatorToggle() {   // demo-webscm 2026 11 02 / ODOO-350612: правый док навигатора интерфейса
			this.store.executeStoreMethod(this, { command: 'navigator_toggle' })
		},
		// IE 2026 11 03 / ODOO-350881 (инвентаризация помощи, этап 1): карточка помощи текущей страницы, вкладкой — её рабочая область (components/HelpCard.vue);
		// иконка ушла в «⋮» или пункт панели пользователя — карточка встаёт у «⋮» / правого края шапки
		helpCardPage() {
			const WS = this.store.activeWORKSPACE, PAGE = WS?.activePAGE
			if (!PAGE) return
			const i = this.rightBarActions.findIndex(a => a.action === 'helpCardPage')
			const btn = i >= 0 ? this.$refs.rightIcons?.querySelectorAll('.tb-right-icon')[i] : null
			const vis = (el) => !!el && el.getClientRects().length > 0
			const anchor = vis(btn) ? btn : (vis(this.$refs.rightMore) ? this.$refs.rightMore : this.$refs.rightIcons)
			const page = { id: String(PAGE.page ?? ''), segment: 'PAGE', type: 'page', title: String(PAGE.title || PAGE.tooltip || PAGE.node?.valueStr || '') }   // название — как у плитки рейла (Page.vue: tooltip, затем node.valueStr)
			const ws = { id: String(WS.record?.id || WS.workspace || ''), segment: String(WS.record?.segment || ''), type: 'workspace', title: String(WS.titleTopBar || WS.title || WS.record?.title || '') }
			helpCard_show({ anchor, vueObj: this, tabs: [{ key: 'page', label: t('Page'), target: page }, ...(ws.id ? [{ key: 'workspace', label: t('Workspace'), target: ws }] : [])] })
		},
		globalChats() {
				this.store.executeStoreMethod(this, { tooltip: t('Open chats'), command: 'widget_open', widget: 'widget-chats' })   // IE 2026 09 23 / ODOO-341407: i18n
			},
			globalSearch() {
			const s = this.store.globalSearch
			if (s.visible) { s.hide() } else { s.show() }
			// 	this.store.executeStoreMethod(this, {'action_name':'action-front-search', 'command':'widget_open', 'widget':'widget-search', workspace: 'workspace-store'})
		},
		globalJob() {
			const s = this.store.globalJob
			if (s.visible) { s.hide() } else { s.show() }
		},
		globalHistory() {
			// грид «Page widgets» вместо кастомного списка (ит.4 п.3)
			this.store.pageWidgets_open()
		},
		globalLog() {
			const s = this.store.globalLog
			if (s.visible) { s.hide() } else { s.show() }
		},
		copyPage() {
			this.store.executeStoreMethod(this, { 'tooltip': t('Copy widgets to clipboard'), 'cssClass':'pi btn-widget-minimize p-button-white mr-0 p-button-text0  pi-copy', 'command': 'copyWidgets' })
		},
		onFullscreen__Click() {
			this.store.executeStoreMethod(this, { 'command': 'onFullscreen__Click', window:true })
		},
		updateSystemTheme(e) {
			// свой выбор пользователя сильнее смены системной темы
			if (this.store?.darkThemePref !== null && this.store?.darkThemePref !== undefined) return;
			if (localStorage.getItem('webscm_darkTheme') !== null) return;
			this.$appState.darkTheme = e.matches;
		},
		// --- Debug backend (ODOO-3178) ---
		openDebug() {   // IE 2026 09 23 / ODOO-341407: i18n
			this.debugDialog.visible = true;
			this.debugDialog.loading = true;
			this.debugDialog.busy = false;
			this.debugDialog.error = '';
			this.debugDialog.note = '';
			this.debugDialog.info = null;
			this.store.executeBackendMethod(this, { command: 'resolve_debug_backend', params: {} }, (answer) => {
				this.debugDialog.loading = false;
				if (!answer || answer.error) {
					this.debugDialog.error = (answer && (answer.message || answer.error)) || t('Failed to resolve debug backend');
				} else {
					this.debugDialog.info = answer;
				}
			});
		},
		debugToggle(enable) {   // IE 2026 09 23 / ODOO-341407: i18n
			this.debugDialog.busy = true;
			this.debugDialog.error = '';
			this.debugDialog.note = '';
			// Toggling debug recreates the very backend that serves this request, so
			// the connection usually drops before a response arrives — executeBackendMethod's
			// error handler does NOT call this callback. Fall back to a timeout that always
			// clears busy and reports the expected outcome, so the dialog never hangs.
			let done = false;
			const timer = setTimeout(() => {
				if (done) return; done = true;
				this.debugDialog.busy = false;
				this.debugDialog.note = t('Command sent — the container is restarting. Reopen Debug in ~1 min to see the new status.');
			}, 7000);
			this.store.executeBackendMethod(this, { command: 'toggle_debug', params: { enable } }, (answer) => {
				if (done) return; done = true;
				clearTimeout(timer);
				this.debugDialog.busy = false;
				if (!answer || answer.error) {
					this.debugDialog.error = (answer && (answer.message || answer.error)) || t('Toggle failed');
				} else {
					this.openDebug(); // re-resolve to reflect the new debug state
				}
			});
		},
		copyText(t) {
			if (!t) return;
			try { navigator.clipboard.writeText(t); } catch (e) { /* ignore */ }
		},
	},
	watch: {
		// IE 2026 09 23 / ODOO-… (заказ Игоря: панель задач в шапке): появилась панель / сменился стол → словари и запрос статусов задач
		tasksPanelOn: { immediate: true, handler(on) { if (on) this.tasksPanel_init() } },
		tasksWs(ws) { if (ws) this.tasksPanel_init() },
		// IE 2026 09 04 / ODOO-336291 (mobile UX): B-08 menuExclusive — состояние «⋮» зеркалится в store.mobileUi.moreOpen; сброс флага снаружи
		// (рейл / гамбургер / список виджетов) закрывает панель
		mobileMenu(v) { if (this.store.mobileUi) this.store.mobileUi.moreOpen = !!v },
		'store.mobileUi.moreOpen'(v) { if (!v && this.mobileMenu) this.mobileMenu = null },
		activeChipsCount() {
			if (this.last_activeChipsCount === this.activeChipsCount) return;
			this.last_activeChipsCount = this.activeChipsCount;
			if (this._chipsObserverPaused && this.$refs.topbarChips) {
				// console.log('Active chips count changed, resuming chips observer');
				this._chipsObserverPaused = false;
				// Cancel the pending nextTick disconnect (if it hasn't run yet).
				this._disconnectToken++;
				this._chipsObserver.observe(this.$refs.topbarChips);
				this._updateChipsMultiRow();
			}
		},
		topbarChipsAttr() {
			this.$nextTick(this._setupChipsObserver);
		},
		pw4: function(){
			this.cnfrmPswdFrmEditValid = this.pw4 !== this.pw3 ? false : true;
		}
	},
	components: {
		DatabasePicker,
		MenuPanel,   // IE 2026 09 22 / ODOO-… (предложение Игоря)
		PmMenuPanel,   // IE 2026 10 26 / ODOO-pending (заказ Игоря 26.10: меню процессной модели — форма меню с группировкой)
		WorkspaceMenuForm,   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p214 єдине меню робочої області — вкладки Меню / Сторінки / Завдання)
		PagesPanel,   // IE 2026 09 26 / ODOO-… (заказ Игоря: виды панели страниц)
		WidgetPreviewImg,   // IE 2026 09 27 / ODOO-… (заказ Игоря: картинки виджетов)
	},
}
</script>

<style scoped>
.topbar-left, .topbar-right {
  flex-shrink: 0; /* сжимается только topbar-chips, иначе глифы иконок вылезают из кнопок и накладываются */
}
.topbar-chips {
  flex: 1;
  min-width: 12rem;
  margin: 0 8px;
  border-radius: 0.5rem; /* мягкое скругление блока чипсов в шапке (в тон иконкам пейджев)
                            (overflow:hidden нельзя — обрежет dropdown чипсов) */
}
/* чипсы топбара: жёсткий width:fill-available у .input-container выталкивал
   кнопку-шеврон (.dropdown-button) ЗА границу контейнера — она накладывалась
   на первую иконку .topbar-right. Правим флекс только для топбара (в гридах
   AttrChips не трогаем): текст чипса и так режется ellipsis'ом в .chip-text */
.topbar-chips :deep(.input-container) {
  width: auto;
  flex: 1 1 auto;
  min-width: 0;
}
.topbar-chips :deep(.dropdown-button) {
  flex-shrink: 0;
}
.topbar-chips {
  --text-color: #495057;
  --text-color-secondary: #6c757d;
  --surface-border: #dee2e6;
  --surface-hover: #e9ecef;
  color: #495057;
  background: white;
}
/* 
* {
  --surface-card:lightslategray;
  --text-color: rgba(255, 255, 255, 0.87);
  --text-color-secondary: rgba(255, 255, 255, 0.6);
} */

/* * {
	color: rgba(255, 255, 255, 0.6);
}
.topbar-menu {
	color: white !important;
} */
.logo {
	background: -webkit-linear-gradient(315deg,#42d392 25%,#647eff);
	-webkit-background-clip:text;
	-webkit-text-fill-color:transparent;
}
.workspace-title {
	font-size: 1.5rem;
	font-weight: 500;
	padding: 0 10px 0 0px;
	color: var(--text-color-secondary);
	font-stretch: ultra-condensed;
}
.process-model-title {
    color: var(--text-color);
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.workspace-title-1 {
	font-stretch: ultra-condensed;
}
.logo3 {
	font-size: 0.875rem;
	font-style: normal;
	/* font-weight: 500; */
	/* padding: 0 25px 0 5px; */
	color: var(--text-color-secondary);
}
.logo_pi {
	font-size: 1rem;
	color: var(--text-color-secondary);
	margin-left: 0rem !important;
}
.layout-flex-center {
	display: flex;
	align-items: center;
}
.widget_modal {
	background: transparent !important;
}
.wj-control {
  background: var(--surface-card);
  color: var(--text-color);
  border: none;
}
.wj-cell {
  background: var(--surface-card);
  color: var(--text-color);
}
.wj-cell.wj-alt {
  background: var(--surface-card);
}
.wj-cell.wj-header {
  background: var(--surface-card);
  color: var(--text-color);
}
 
.p-link-topbar {
    margin: 0;
	display: inline-flex;
	justify-content: center;
	align-items: center;
	position: relative;
	color: var(--text-color-secondary);
	border-radius: 50%;
	cursor: pointer;
	transition: background-color 0.2s;

    padding: 0 5px 0 5px;
    list-style: none;
}
/* IE 2026 09 04 / ODOO-336291 (mobile UX): P-25 — ховер только устройствам с курсором (на таче :hover залипает после тапа) */
@media (hover: hover) {
.p-link-topbar:hover {
	color: var(--text-color);
}
}
.p-link-topbar i {
    font-size: 1rem;
}
.p-link-topbar-1 i {
	font-size: 1.5rem;
	transform: scaleX(0.85);
}
/* IE 2026 09 22 / ODOO-… (предложение Игоря, шаг 2): имя пользователя — кнопка панели функций (в гаммах цвет даёт правило .layout-topbar .p-link из App.vue) */
.topbar-right-2 :deep(.user-menu-btn) {
	color: var(--text-color);
	font-stretch: ultra-condensed;
	padding: 0 4px;
	max-width: 220px;
}
.topbar-right-2 :deep(.user-menu-title) {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
/* IE 2026 09 22 / ODOO-… (предложение Игоря): иконка панели функций страницы (кнопка живёт в дочернем MenuPanel — :deep) */
/* IE 2026 09 22 / ODOO-… (заказ Игоря): вторая иконка шапки — панель страниц стола, слева от панели страницы */
.workspace-menu :deep(.pages-menu-btn) {
	margin-right: 2px;
}
/* IE 2026 09 22 / ODOO-… (заказ Игоря, п.5): заголовок в шапке — триггер панели страниц (кнопка MenuPanel со слотом): вид прежний, по наведению / открытой панели — темнее */
.topbar-left-1 :deep(.workspace-title-btn) { padding: 0; }
/* IE 2026 09 23 (замечание Игоря: «при открытии пейджев не видно название рабочего пространства»): цвет заголовка по наведению и при открытой
   панели НЕ меняется (--text-color сливался с тёмным топбаром гамм style2o / 3k / 4s / 7w), признак — подчёркивание текущим цветом */
@media (hover: hover) {
.topbar-left-1 :deep(.workspace-title-btn:hover .workspace-title), .topbar-left-1 :deep(.workspace-title-btn.is-open .workspace-title) {
    text-decoration: underline; text-decoration-thickness: 2px; text-underline-offset: 3px; }
}
.workspace-menu :deep(.page-menu-btn), .workspace-menu :deep(.tasks-menu-btn) {
	color: var(--text-color-secondary);
	padding: 0 6px;
	border-radius: 6px;
}
@media (hover: hover) {
.workspace-menu :deep(.page-menu-btn:hover), .workspace-menu :deep(.page-menu-btn.is-open), .workspace-menu :deep(.tasks-menu-btn:hover), .workspace-menu :deep(.tasks-menu-btn.is-open) {
	color: var(--text-color);
}
}
/* IE 2026 09 23 / ODOO-… (заказ Игоря: панель задач в шапке): третья иконка после панели меню страницы; бейдж числа ошибок — правый верхний угол кнопки */
.workspace-menu :deep(.tasks-menu-btn) { margin-left: 2px; }
.workspace-menu :deep(.tasks-menu-btn .menu-panel-btn-badge) { top: -4px; right: -2px; }
/* IE 2026 09 26 / ODOO-… (замечания Игоря: рейл и шапка) (п. 3.3): название стола — триггер панели задач; красный бейдж ошибок — сразу за названием (место под него) */
.topbar-left-1 :deep(.tasks-title-btn) { margin-right: 14px; }
/* IE 2026 10 03 / ODOO-345044 (заказ Игоря: кнопка «Страницы» в шапку, hover-меню с задержкой, скрытие рейки кнопкой в меню): кнопка «Страницы» в шапке — как иконки ⊞ / задач рядом; пока рейл скрыт — приглушена */
/* IE 2026 10 08 / ODOO-5800: кнопка «Страницы» живёт в topbar-left-2 (вместе с ⊞ переносится на вторую строку); блок не рвётся */
.topbar-left-2 { flex-wrap: nowrap; white-space: nowrap; }
.topbar-left-2 :deep(.pages-topbar-btn) { color: var(--text-color-secondary); padding: 0 6px; border-radius: 6px; margin-right: 2px; flex-shrink: 0; }
.topbar-left-2 :deep(.pages-topbar-btn.rail-toggle-hidden) { opacity: .6; }
@media (hover: hover) {
.topbar-left-2 :deep(.pages-topbar-btn:hover), .topbar-left-2 :deep(.pages-topbar-btn.is-open) { color: var(--text-color); opacity: 1; }
}
.topbar-left-1 :deep(.tasks-title-btn .menu-panel-btn-badge) { top: -3px; right: -15px; }
.logo_pi.no-current-process_model, .process-model-title.no-current-process_model {
	color: #FFC107;
}
.layout-topbar.no-current-process_model {
	box-shadow: inset 0 3px 5px #ffc107,
            inset 0 0 2px rgba(0, 0, 0, .05),
            inset 0 1px 4px rgba(0, 0, 0, .08);
}
/* красная сигнализация стола (критические задачи) — приоритетнее амбера */
.layout-topbar.workspace-alarm {
	box-shadow: inset 0 3px 5px #e53935,
            inset 0 0 2px rgba(0, 0, 0, .05),
            inset 0 1px 4px rgba(0, 0, 0, .08);
}
/* IE 2026 09 29 / ODOO-342781: бейдж роли «только чтение» в шапке — жёлтая плашка с замком; на узкой шапке — только замок */
.ro-badge {
	display: inline-flex;
	align-items: center;
	gap: .35rem;
	margin-left: .6rem;
	padding: 0 .6rem;
	height: 1.5rem;
	border-radius: 999px;
	font-size: .75rem;
	font-weight: 600;
	white-space: nowrap;
	cursor: default;
	color: #6b4e00;
	background: #fff1b8;
	border: 1px solid #f0c23b;
}
.ro-badge .pi { font-size: .75rem; }
/* IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): бейдж и значок архивной ПМ — янтарные, как значок архива в меню модели */
.ro-badge.ro-badge-archive { color: #8a5a00; border-color: #e0b252; background: #fff6e0; }
.logo_pi.pm-archive-icon { color: #8a5a00; }
@media (max-width: 720px) {
	.ro-badge { padding: 0 .4rem; }
	.ro-badge .ro-badge-text { display: none; }
}
.workspace-alarm-icon {
	color: #e53935;
	margin-left: .4rem;
	cursor: pointer;
	animation: workspace-alarm-blink 1.6s ease-in-out infinite;
}
@keyframes workspace-alarm-blink {
	50% { opacity: .35; }
}
.workspace-alarm-overlay {
	position: fixed;
	inset: 0;
	background: rgba(0, 0, 0, .45);
	z-index: 10000;
	display: flex;
	align-items: center;
	justify-content: center;
}
.workspace-alarm-dialog {
	/* диалог живёт внутри топбара: без явного цвета текст наследовал белый
	   цвет топбара — названия задач были белым по белому */
	color: var(--text-color, #333);
	background: var(--surface-a, #fff);
	border-top: 4px solid #e53935;
	border-radius: 6px;
	box-shadow: 0 8px 32px rgba(0, 0, 0, .35);
	max-width: 720px;
	width: 92%;
	max-height: 70vh;
	display: flex;
	flex-direction: column;
	padding: 1rem 1.25rem;
}
.workspace-alarm-header {
	display: flex;
	align-items: center;
	gap: .5rem;
	font-size: 1.1rem;
	font-weight: 600;
	color: #e53935;
	margin-bottom: .75rem;
}
.workspace-alarm-rows {
	overflow-y: auto;
	display: flex;
	flex-direction: column;
	gap: .4rem;
}
.workspace-alarm-row {
	display: flex;
	align-items: baseline;
	gap: .6rem;
	font-size: .9rem;
	border-bottom: 1px dotted var(--surface-d, #ddd);
	padding-bottom: .3rem;
}
.workspace-alarm-badge {
	flex-shrink: 0;
	padding: .05rem .45rem;
	border-radius: 3px;
	font-size: .78rem;
	color: #fff;
	background: #e53935;
}
.workspace-alarm-badge.workspace-alarm-stuck {
	background: #fb8c00;
}
.workspace-alarm-task {
	font-weight: 600;
	flex-shrink: 0;
}
.workspace-alarm-comment {
	color: var(--text-color-secondary, #666);
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.workspace-alarm-date {
	margin-left: auto;
	flex-shrink: 0;
	color: var(--text-color-secondary, #666);
	font-size: .8rem;
}
.workspace-alarm-footer {
	margin-top: .9rem;
	text-align: right;
}
.workspace-alarm-close {
	padding: .35rem 1.2rem;
}
.topbar-left-1, .topbar-left-2, .topbar-right-1, .topbar-right-2 {
	display: flex;
	align-items: center;
}
/* свёрнутые правые иконки — выпадающее меню под «⋮» */
.topbar-right-1 {
	position: relative;
}
.topbar-right-overflow {
	position: absolute;
	top: 100%;
	right: 0;
	z-index: 1100;
	margin-top: 4px;
	padding: 4px;
	background: #fff;
	border: 1px solid var(--surface-border, #dee2e6);
	border-radius: 0.5rem;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
	display: flex;
	flex-direction: column;
	min-width: 180px;
}
.topbar-right-overflow-item {
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 8px 12px;
	border: none;
	background: transparent;
	color: var(--text-color, #495057);
	font-size: 0.9rem;
	cursor: pointer;
	border-radius: 6px;
	text-align: left;
	white-space: nowrap;
}
@media (hover: hover) { /* IE 2026 09 04 / ODOO-336291 (mobile UX): P-25 */
.topbar-right-overflow-item:hover {
	background: var(--surface-hover, #e9ecef);
}
}
/* секции свёрнутых меню в «⋮»: колонкой, тёмный текст на белой панели */
.topbar-overflow-menus {
	display: flex;
	flex-direction: column;
	gap: 2px;
	padding: 4px 6px;
	border-bottom: 1px solid var(--surface-border, #dee2e6);
}
.topbar-overflow-menus:last-child {
	border-bottom: none;
	border-top: 1px solid var(--surface-border, #dee2e6);
}
.topbar-overflow-menus .wj-menu,
.topbar-overflow-menus .workspace-title-1 {
	color: var(--text-color, #495057);
}
.topbar-overflow-menus .logo_pi {
	color: var(--text-color-secondary, #6c757d);
	margin-right: 6px;
}
/* IE 2026 10 08 / ODOO-5800: строки «⋮» с теми же формами, что у кнопок широкой шапки — кнопка-триггер на всю строку (иконка + подпись), всплывашка базы под строкой */
.topbar-overflow-menus .ovm-same { padding: 0; position: relative; }
.topbar-overflow-menus .ovm-same .menu-panel-host { display: flex; width: 100%; }
.topbar-overflow-menus .ovm-same-btn { display: flex; align-items: center; gap: 10px; width: 100%; padding: 8px 12px; color: var(--text-color, #495057); font-size: 0.9rem; white-space: nowrap; cursor: pointer; border-radius: 6px; text-decoration: none; max-width: none; }
.topbar-overflow-menus .ovm-same-btn .logo_pi, .topbar-overflow-menus .ovm-same-btn > i { margin: 0; width: 16px; text-align: center; }
.topbar-overflow-menus .ovm-same-btn .user-menu-title { color: inherit; }
@media (hover: hover) { .topbar-overflow-menus .ovm-same-btn:hover, .topbar-overflow-menus .ovm-same-btn.is-open { background: var(--surface-hover, #e9ecef); } }
.topbar-left.chips-single-row {
	display: flex;
	align-items: center;
}
/* IE 2026 10 08 / ODOO-5800: многострочный режим (чипсы в несколько строк): строка 1 — название стола (topbar-left-1 на всю ширину), строка 2 — ☰ + «Страницы» + ⊞ вместе */
.topbar-left:not(.chips-single-row) {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
}
.topbar-left:not(.chips-single-row) .topbar-left-1 { order: 1; flex: 0 0 100%; }
.topbar-left:not(.chips-single-row) .topbar-ws-btn { order: 2; }
.topbar-left:not(.chips-single-row) .topbar-left-2 { order: 3; }
.topbar-right {
	display: flex;
	flex-direction: column-reverse;
}
.topbar-right.chips-single-row {
	display: flex;
	flex-direction: row;
}

/* Debug backend panel (ODOO-3178) */
.debug-panel { font-size: 0.9rem; line-height: 1.5; }
.debug-panel .debug-row { margin-bottom: 0.4rem; word-break: break-word; }
.debug-panel code { background: rgba(127,127,127,0.15); padding: 1px 5px; border-radius: 3px; font-size: 0.82rem; }
.debug-panel .debug-tunnel { display: inline-block; max-width: 100%; overflow-x: auto; white-space: nowrap; vertical-align: bottom; }
.debug-muted { color: #888; font-size: 0.82rem; }
.debug-hint { margin: -0.2rem 0 0.5rem 0; }
.debug-on { color: #1a9d4b; font-weight: 600; }
.debug-off { color: #888; font-weight: 600; }
.debug-err { color: #d13438; }
.debug-footer-err { margin-top: 0.5rem; }
.debug-busy { margin-top: 0.5rem; font-style: italic; }
.debug-guard { margin: 0.6rem 0; padding: 0.5rem 0.7rem; border-radius: 4px; background: rgba(209,52,56,0.10); border: 1px solid rgba(209,52,56,0.35); color: #b3282c; }
.debug-linkrow { display: flex; align-items: center; gap: 0.5rem; }
.debug-copy { border: 1px solid rgba(127,127,127,0.4); background: transparent; color: inherit; border-radius: 3px; padding: 0 6px; font-size: 0.75rem; cursor: pointer; }
.debug-copy:hover { background: rgba(127,127,127,0.15); }
.debug-btn { border: 1px solid rgba(127,127,127,0.4); background: transparent; color: inherit; border-radius: 4px; padding: 0.35rem 0.9rem; cursor: pointer; font-size: 0.88rem; }
.debug-btn:hover:not(:disabled) { background: rgba(127,127,127,0.12); }
.debug-btn:disabled { opacity: 0.5; cursor: default; }
.debug-btn-primary { background: #2563eb; border-color: #2563eb; color: #fff; }
.debug-btn-primary:hover:not(:disabled) { background: #1d4ed8; }

/* Database picker popup (ODOO-3483) */
.db-chip-wrap {
	position: relative;
}
.db-chip {
	color: var(--text-color);
	cursor: pointer;
	max-width: 200px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	padding: 0 4px;
}
.db-chip:hover {
	color: var(--primary-color, #2997ff);
}
.db-picker-popup {
	position: absolute;
	top: calc(100% + 8px);
	right: 0;
	z-index: 1000;
	width: 480px;
	max-width: calc(100vw - 24px);
	max-height: calc(100vh - 80px);
	display: flex;
	flex-direction: column;
	background: #fff;
	border: 3px solid rgba(255,150,30,.75); /* log-widget frame */
	border-radius: 0.5rem;
	padding: 0.5rem;
	box-shadow: 0 4px 8px rgba(55, 63, 66, 0.07), 0 8px 16px rgba(55, 63, 66, 0.07), 0 16px 24px rgba(55, 63, 66, 0.07);
}
.db-picker-popup .dbp {
	min-height: 0;
}
</style>